/*! js-cookie v3.0.0-rc.1 | MIT */
!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define(t)
      : ((e = e || self),
        (function () {
          var n = e.Cookies,
            r = (e.Cookies = t());
          r.noConflict = function () {
            return (e.Cookies = n), r;
          };
        })());
})(this, function () {
  'use strict';
  function e(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) e[r] = n[r];
    }
    return e;
  }
  var t = {
    read: function (e) {
      return e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function (e) {
      return encodeURIComponent(e).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent,
      );
    },
  };
  return (function n(r, o) {
    function i(t, n, i) {
      if ('undefined' != typeof document) {
        'number' == typeof (i = e({}, o, i)).expires &&
          (i.expires = new Date(Date.now() + 864e5 * i.expires)),
          i.expires && (i.expires = i.expires.toUTCString()),
          (t = encodeURIComponent(t)
            .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
            .replace(/[()]/g, escape)),
          (n = r.write(n, t));
        var c = '';
        for (var u in i)
          i[u] &&
            ((c += '; ' + u), !0 !== i[u] && (c += '=' + i[u].split(';')[0]));
        return (document.cookie = t + '=' + n + c);
      }
    }
    return Object.create(
      {
        set: i,
        get: function (e) {
          if ('undefined' != typeof document && (!arguments.length || e)) {
            for (
              var n = document.cookie ? document.cookie.split('; ') : [],
                o = {},
                i = 0;
              i < n.length;
              i++
            ) {
              var c = n[i].split('='),
                u = c.slice(1).join('=');
              '"' === u[0] && (u = u.slice(1, -1));
              try {
                var f = t.read(c[0]);
                if (((o[f] = r.read(u, f)), e === f)) break;
              } catch (e) {}
            }
            return e ? o[e] : o;
          }
        },
        remove: function (t, n) {
          i(t, '', e({}, n, { expires: -1 }));
        },
        withAttributes: function (t) {
          return n(this.converter, e({}, this.attributes, t));
        },
        withConverter: function (t) {
          return n(e({}, this.converter, t), this.attributes);
        },
      },
      {
        attributes: { value: Object.freeze(o) },
        converter: { value: Object.freeze(r) },
      },
    );
  })(t, { path: '/' });
});

jQuery.fn.reverse = [].reverse;

var bundleErrorMsg =
  'Error in one of your products. You will be redirected to update your products';
var errorTitle = 'Encountered an error!';

var $parentBlock = '';
var sizeWidthArr = [];
var sizeHeightArr = [];

var yWidthVal_1 = 0;
var yWidthVal_2 = 0;

var xWidth = 0;
var xHeight = 0;

// TODO reuse configuration object to set up / manipulate state
var xCat = $('.builderWrapper').attr('data-type');
let productData = null;
const productElement = document.getElementById(
  'ProductJson-product-template-builder',
);

if (productElement) {
  productData = JSON.parse(productElement.innerHTML);
  productData.previousQuantity = parseInt($('#builderQty').val());
}

// used for displaying selected option in new builder
$('body').on('change', '.builder-step input', function () {
  console.info('updating chosen input display...');
  // get the text for the chosen option - this is different than the 'swatch' value
  let chosenOption = $(this).attr('data-property');

  $(this).closest('.builder-step').find('.chosen-option');
});

// used for opening / closing builder steps (aka blocks)
// onclick 'next' button open step based on step number
function openBuilderStep(id) {
  console.log('opening builder...');
  $('.builder-option').hide();
  $('#builder-option-' + id).fadeIn(200);

  $('html, body').animate(
    {
      scrollTop: $('#builder-option-' + id).offset().top - 200,
    },
    300,
  );
}

// onclick of option title open chosen step
// and close other builder steps
function toggleBuilderStep(id) {
  $('.builder-option').fadeOut(300);
  $('#builder-option-' + id).toggle();
}

function displayChosenOption(step, option) {}

// loop blocks and combine prent and sub block
$('.builderBlock').each(function () {
  var isSub = $(this).hasClass('subBlock');
  var blockType = $(this).attr('data-type');
  var $block = $(this);
  if (blockType == 'multi') {
  } else {
    if (isSub == true) {
      $parentSize = $(
        '.builderBlock.parentBlock[data-question="' + $parentBlock + '"]',
      );
      var variantHTML = $block.find('.prodvariant').html();
      // combine all variant and remove sub block
      $parentSize.find('.prodvariant').append(variantHTML);
      $block.remove();
    } else {
      $parentBlock = $(this).attr('data-question');
    }
  }
});
// loop block again and format based on block type
$('.builderBlock').each(function () {
  var $block = $(this);
  var blockType = $block.attr('data-type');
  if (blockType == 'size') {
    // if size block
    // TODO this should be generated based upon product properties, not inferred by a list of variants' names, this approach is fragile
    var items = $(this).find('.prodvariant option');
    items.sort(function (a, b) {
      return +$(a).data('identifier') - +$(b).data('identifier');
    });
    items.appendTo($(this).find('.prodvariant'));

    $block.find('.prodvariant option').each(function () {
      var xTxtArr = $.trim($(this).text()).split('x');
      sizeWidthArr.push(parseInt(xTxtArr[0]));
      sizeHeightArr.push(parseInt(xTxtArr[1]));
    });

    sizeWidthArr = unique(sizeWidthArr);
    sizeHeightArr = unique(sizeHeightArr);

    var minWidth = Math.min.apply(null, sizeWidthArr);
    var maxWidth = Math.max.apply(null, sizeWidthArr);

    sizeWidthArrInc = [];
    for (var i = minWidth; i <= maxWidth; i++) {
      sizeWidthArrInc.push(i);
    }

    var minHeight = Math.min.apply(null, sizeHeightArr);
    var maxHeight = Math.max.apply(null, sizeHeightArr);
    sizeHeightArrInc = [];
    for (var i = minHeight; i <= maxHeight; i++) {
      sizeHeightArrInc.push(i);
    }
    // build size opt select
    $block.find('.sizeEntry.width .parentSize').html('');
    $block.find('.sizeEntry.height .parentSize').html('');
    $.each(sizeWidthArrInc, function (key, value) {
      $block
        .find('.sizeEntry.width .parentSize')
        .append('<option value="' + value + '">' + value + '</option>');
      $('.builderBlock[data-type="headrail"] #width-crtl-inch-1').append(
        '<option value="' + value + '">' + value + '</option>',
      );
      $('.builderBlock[data-type="headrail"] #width-crtl-inch-2').append(
        '<option value="' + value + '">' + value + '</option>',
      );
    });
    $.each(sizeHeightArrInc, function (key, value) {
      $block
        .find('.sizeEntry.height .parentSize')
        .append('<option value="' + value + '">' + value + '</option>');
    });
  } else if (blockType == 'color') {
    // if color block
    //build color swatch
    $block.find('.swatchEntry.color').html('');
    $block.find('.prodvariant option').each(function () {
      var cTitle = $.trim($(this).text());
      var cName = 'swatchColor_' + $block.attr('data-block-index');
      var cImg = $(this).attr('data-image');
      var cVal = $(this).attr('value');
      var swatchCode =
        '<li><label class="control builder__control"><input type="radio" title="' +
        cTitle.toLowerCase() +
        '" name="' +
        cName +
        '" value="' +
        cVal +
        '" /><span class="builder__control-indicator"></span><span class="builder__control-item"><img src="' +
        cImg +
        '" /></span><span class="builder__control-label text-small">' +
        cTitle +
        '</span></label></li>';
      if (cVal != '') {
        $('.swatchEntry.color').append(swatchCode);
      }
    });
  } else if (blockType == 'normal' || blockType == 'sub') {
    // normal block
    $block.find('.swatchEntry.normal').html('');
    $block.find('.prodvariant option').each(function () {
      var cTitle = $.trim($(this).text()).split(' - ')[0];
      var cName = 'swatchColor_' + $block.attr('data-block-index');
      var cImg = $(this).attr('data-image');
      var cPrice = parseFloat($(this).attr('data-price'));
      var cVal = $(this).attr('value');
      var cSKU = $(this).attr('data-sku');
      var cNotice = $(this).attr('data-notice');
      var cShowNotice = $(this)
        .closest('.builderBlock')
        .attr('variant-notice-selection');
      var cNoticeHTML = '';
      var cPriceHTML = '';
      var privacyClass = '';
      var addedClass = '';

      if (cNotice != '' && cShowNotice == 'false') {
        cNoticeHTML =
          '<div class="notice"><small class="text-small">' +
          cNotice +
          '</small></div>';
      }
      if (cPrice > 0) {
        cPriceHTML =
          '<abbr class="plusPrice"> + $' + cPrice.toFixed(2) + '</abbr>';
      }

      //ADDED BY BLUESWITCH TO TAG PRIVACY SLATS.
      //ADDED BY BLUESWITCH FOR ROUNDED CORNERS
      if (cTitle.toLowerCase().includes('privacy slats')) {
        var privacyClass = 'class="privacy-slat"';
      }

      //ADDED BY BLUESWITCH TO TAG VALENCE.
      if (cTitle.toLowerCase().includes('inside mount fully recessed')) {
        var addedClass = 'class="valance-opt-fr valance-radio"';
      } else if (
        cTitle.toLowerCase().includes('inside mount partially recessed')
      ) {
        var addedClass = 'class="valance-opt-pr valance-radio"';
      } else if (cTitle.toLowerCase().includes('outside mount not recessed')) {
        var addedClass = 'class="valance-opt-nr valance-radio"';
      } else if (
        cTitle
          .toLowerCase()
          .includes(
            'inside mount (factory determined deduction will be taken)',
          ) ||
        cTitle
          .toLowerCase()
          .includes('outside mount (no deduction will be taken)')
      ) {
        var addedClass = 'class="valance-opt"';
      }
      //ADDED BY BLUESWITCH FOR ROUNDED CORNERS
      else if (
        cTitle
          .toLowerCase()
          .includes(
            'round corner valance (available on outside mount blinds only)',
          )
      ) {
        var addedClass = 'class="valance-opt-rounded  valance-radio"';
      }

      //ADDED CLOTH TAPE CLASS
      if (cTitle.toLowerCase().includes('cloth tape')) {
        var addedInputClass = 'class="cloth-tape"';
      }

      var swatchCode =
        '<li ' +
        privacyClass +
        ' ' +
        addedClass +
        ' data-sku="' +
        cSKU +
        '"><label class="control builder__control"><input ' +
        addedInputClass +
        ' type="radio" title="' +
        cTitle.toLowerCase() +
        '" name="' +
        cName +
        '" value="' +
        cVal +
        '" /><span class="builder__control-indicator"></span><span class="builder__control-item"><img src="' +
        cImg +
        '" /></span><span class="builder__control-label text-large">' +
        cTitle +
        cPriceHTML +
        '</span>' +
        cNoticeHTML +
        '</label></li>';

      if (cVal != '') {
        $block.find('.swatchEntry.normal').append(swatchCode);
      }
    });
  } else if (blockType == 'multiple') {
    // multiple selection swatch
    $block.find('.swatchEntry.multiple').html('');
    $block.find('.prodvariant option').each(function () {
      var cTitle = $.trim($(this).text());
      var cName = 'swatchColor_' + $block.attr('data-block-index');
      var cImg = $(this).attr('data-image');
      var cPrice = parseFloat($(this).attr('data-price'));
      var cVal = $(this).attr('value');
      var cNotice = $(this).attr('data-notice');
      var cNoticeHTML = '';
      var cPriceHTML = '';
      if (cNotice != '') {
        cNoticeHTML =
          '<div class="notice"><small>' + cNotice + '</small></div>';
      }
      if (cPrice > 0) {
        cPriceHTML =
          '<abbr class="plusPrice"> + $' + cPrice.toFixed(2) + '</abbr>';
      }

      var swatchCode =
        '<li><label class="control builder__control"><input type="checkbox" title="' +
        cTitle.toLowerCase() +
        '" name="' +
        cName +
        '" value="' +
        cVal +
        '" /><span class="builder__control-indicator"></span><span class="builder__control-item"><img src="' +
        cImg +
        '" /></span><span class="builder__control-label text-large">' +
        cTitle +
        cPriceHTML +
        '</span>' +
        cNoticeHTML +
        '</label></li>';

      if (cVal != '') {
        $block.find('.swatchEntry.multiple').append(swatchCode);
      }
    });
  }
});

// change color
$('body').on('change', '.swatchEntry.color input', function () {
  // console.info(`Changing color:`);
  var colorPropkey = '';
  var colorPropVal = '';

  var cChecked = $(this).closest('.swatchEntry').find('input:checked').val();
  var cCheckedTxt = $.trim(
    $(this)
      .closest('.builderBlock')
      .find('.prodvariant option[value="' + cChecked + '"]')
      .text(),
  );
  $(this)
    .closest('.builderBlock')
    .find('.prodvariant')
    .val(cChecked)
    .trigger('change');
  // set property
  $(this)
    .closest('.builderBlock')
    .find('[data-property]')
    .val(cCheckedTxt)
    .trigger('change');
  $(this).closest('.builderBlock').addClass('hasEdited');

  trackProductConfig(productData, 'choose color', cCheckedTxt.toLowerCase());
});

// change swatch
$('body').on('change', '.swatchEntry.normal input', function () {
  // console.info(`Changing swatch:`);
  $(this).closest('.builderBlock').addClass('hasEdited');
  var blockType = $(this).closest('.builderBlock').attr('data-type');
  //console.log('blockType:'+blockType);
  if (blockType == 'multiple') {
    // console.info(`Multiple swatch / blockType is 'multiple'.`);
    // multiple swatch
    var swatchProp = '';
    var swatchCheckedIndex = 0;
    var pVariant = $(this).closest('.builderBlock').find('.prodvariant');
    pVariant.find('option').prop('selected', false);
    $(this)
      .closest('.swatchEntry')
      .find('input')
      .each(function () {
        if (this.checked) {
          //cCheckedArr.push();
          var sThisVal = $(this).val();
          var thisText = $.trim(
            pVariant.find('option[value="' + sThisVal + '"]').text(),
          );
          pVariant
            .find('option[value="' + sThisVal + '"]')
            .prop('selected', true);

          if (swatchCheckedIndex == 0) {
            swatchProp = swatchProp + thisText;
          } else {
            swatchProp = swatchProp + ', ' + thisText;
          }
          swatchCheckedIndex += 1;
        }
      });
    $(this).closest('.parentBlock').find('.prodvariant').trigger('change');
    $(this)
      .closest('.parentBlock')
      .find('[data-property]')
      .val(swatchProp)
      .trigger('change');
  } else {
    // console.info(`Single swatch.`);
    // single swatch
    var cChecked = $(this).closest('.swatchEntry').find('input:checked').val();
    var cCheckedTitle = $(this)
      .closest('.swatchEntry')
      .find('input:checked')
      .attr('title')
      .toLowerCase();
    var cCheckedTxt = $.trim(
      $(this)
        .closest('.builderBlock')
        .find('.prodvariant option[value="' + cChecked + '"]')
        .text(),
    ).split(' - ')[0];
    $(this)
      .closest('.builderBlock')
      .find('.prodvariant')
      .val(cChecked)
      .trigger('change');

    // set property
    $(this)
      .closest('.parentBlock')
      .find('[data-property]')
      .val(cCheckedTxt)
      .trigger('change');

    var $parentBlock = $(this).closest('.parentBlock');
    var parentQuestion = $parentBlock.attr('data-question').toLowerCase();
    if (parentQuestion.indexOf('mount type') >= 0) {
      //validate mount
      //checkValanceOptions(cCheckedTitle);
    }
    if (parentQuestion.indexOf('roll direction') >= 0) {
      //validate mount
      //validateCassetteValance(cCheckedTitle);
    }

    trackProductConfig(
      productData,
      parentQuestion.replace('choose ', ''),
      cCheckedTitle,
    );

    //console.log('parentQuestion:'+parentQuestion);
    //console.log('cCheckedTitle:'+cCheckedTitle);

    // check remote control zebra shades
    //console.log('parentQuestion:'+parentQuestion)
    // if (parentQuestion.indexOf('lift cord') >= 0) {
    //   //console.log('cCheckedTitle:'+cCheckedTitle);
    //   if (cCheckedTitle == 'motorized') {
    //     $('.builderBlock[data-question*="remote control"]').show();
    //     $('.builderBlock[data-question*="remote control"] .prodvariant').attr('data-add', true).prop('required',true);
    //     $('.builderBlock[data-question*="remote control"] [data-property]').prop('required',true);
    //   } else {
    //     $('.builderBlock[data-question*="remote control"]').hide();
    //     $('.builderBlock[data-question*="remote control"] .prodvariant').attr('data-add', false).prop('required',false);
    //     $('.builderBlock[data-question*="remote control"] [data-property]').prop('required',false);
    //     $('.builderBlock[data-question*="remote control"] .errorMsg').remove();
    //   }
    // }
  }
});

// change size
// obviously
$('body').on('change', '.parentSize', function (event) {
  // console.info(`Changing size from parentSize`);
  let $selectElement = $(event.target);
  // disable fractional size if largest dimension is chosen
  if ($selectElement.find('option').last().prop('selected')) {
    $selectElement
      .closest('.sizeEntry')
      .find('.subSize')
      .val('')
      .prop('disabled', true);
  } else {
    $selectElement
      .closest('.sizeEntry')
      .find('.subSize')
      .prop('disabled', false)
      .val('.0');
  }

  let productJSON = JSON.parse(
    document.getElementById('ProductJson-product-template-builder').innerHTML,
  );

  if (
    $selectElement[0].id == 'width-select' &&
    productJSON.id == 6095138947240
  ) {
    let $parentBlock = $(this).closest('.parentBlock');
    let chosenWidth = event.target.value;
    // console.info(`chosen width is ${chosenWidth}`);

    // restrict length to 84" if width is above 94" for Modern Fabric Blackout Roller Shades
    if (chosenWidth > 94) {
      restrictLengthForModernFabricBlackoutRollerShades();
    } else {
      // re-enable length aka height of greater than 84" if width was adjusted out of the restriction...
      // TODO this is hacky, should only re-enable if it's disabled
      const heightInput = document.getElementById('height-select');

      Array.from(
        document.getElementById('height-select').getElementsByTagName('option'),
      )
        .filter(function (option) {
          return option.value > 84;
        })
        .forEach(function (option) {
          option.disabled = false;
        });
      document.getElementById(
        'modernBlackoutHeightRestrictionWrapper',
      ).style.display = 'none';
      document.getElementById('modernBlackoutHeightRestriction').innerText = '';

      // ...and also the fractional sizing if necessary
      if (
        $(heightInput)
          .closest('.sizeEntry')
          .find('.subSize')
          .prop('disabled') == true
      ) {
        $(heightInput)
          .closest('.sizeEntry')
          .find('.subSize')
          .prop('disabled', false)
          .val('.0');
      }
    }
  }

  if (
    productJSON.id == 6095138947240 &&
    $selectElement[0].id == 'height-select' &&
    event.target.value >= 84 &&
    restrictLengthForModernFabricBlackoutRollerShades()
  ) {
    // console.info('restricting fractional height due to height change');
    $selectElement
      .closest('.sizeEntry')
      .find('.subSize')
      .val('')
      .prop('disabled', true);
  }

  // console.info(`Sizing adjusted 1:`);
});

// this is super specific for now, gross
function restrictLengthForModernFabricBlackoutRollerShades() {
  console.info(`Restrict length for Modern Fabric Black Roller Shades:`);
  // change length aka height to 84" if it happened to be larger already
  const heightInput = document.getElementById('height-select');
  let chosenHeight = parseFloat(heightInput.value);

  if (chosenHeight >= 84) {
    // console.info(`chosen height is above 84", adjusting and disabling...`);
    heightInput.value = 84;

    // don't forget the fractional amount !
    $(heightInput)
      .closest('.sizeEntry')
      .find('.subSize')
      .val('')
      .prop('disabled', true);
  }

  // and then disable length aka height options above 84"
  Array.from(
    document.getElementById('height-select').getElementsByTagName('option'),
  )
    .filter(function (option) {
      return option.value > 84;
    })
    .forEach(function (option) {
      option.disabled = true;
    });
  document.getElementById(
    'modernBlackoutHeightRestrictionWrapper',
  ).style.display = 'block';
  document.getElementById('modernBlackoutHeightRestriction').innerText =
    'Shades with width greater than 94" cannot have a length exceeding 84"';

  return true;
}

$('body').on('change', '.parentSize, .subSize', function () {
  // console.info(`Changing based on sub-size:`);
  $(this).closest('.builderBlock').addClass('hasEdited');
  var $parentBlock = $(this).closest('.parentBlock');
  var sizeProp = '';

  $parentBlock.find('.sizeEntry').each(function () {
    var $parentSel = $(this).find('.parentSize');
    var parentSize = $parentSel.val();

    var subSizeSel = $(this).find('.subSize');
    var subSize = $(this).find('.subSize').val();

    var sizeSel = parentSize + subSize;
    $(this).attr('data-size', sizeSel);
  });
  let xWidth = parseFloat(
    $parentBlock.find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $parentBlock.find('.sizeEntry.height[data-size]').attr('data-size'),
  );

  // set line item property
  var xWidthNum = Math.floor(xWidth);

  var xWidthDec = xWidth - Math.floor(xWidth);
  if (xWidthDec != '') {
    xWidthDec = ' ' + decimalToFraction(xWidthDec);
  }
  var xHeightNum = Math.floor(xHeight);
  var xHeightDec = xHeight - Math.floor(xHeight);
  if (xHeightDec != '') {
    xHeightDec = ' ' + decimalToFraction(xHeightDec);
  }

  // TODO investigate whether we should use widthVal / heightVal for lookup
  var widthVal = xWidthNum + xWidthDec + '"';
  var heightVal = xHeightNum + xHeightDec + '"';

  sizeProp = 'Width: ' + widthVal + ', Height: ' + heightVal;

  // TODO what is happening here?
  $(this)
    .closest('.parentBlock')
    .find('[data-property]')
    .val(sizeProp)
    .trigger('change');

  // input size prop into chosen-option for new builder
  // TODO is this the best place for this?
  // size is a special case
  $('#chosen-option-size').html(sizeProp);

  // get variant breaks
  // console.info('checking variant price grid:');

  let variants = document
    .getElementById('variant-select')
    .querySelectorAll('option');

  // TODO get list of widths from variants 'cause sizeWidthArr is global and not to be trusted
  let closestWidth = closest(xWidth, sizeWidthArr);

  // TODO refactor all of this out to more granular functions
  let variantsByWidth = [];

  // gross stuff 'cause IE
  Array.prototype.forEach.call(variants, function (o) {
    if (o.getAttribute('data-identifier') === closestWidth.toString()) {
      variantsByWidth.push(o);
    }
  });

  let availableHeights = [];

  // gross stuff 'cause IE
  Array.prototype.forEach.call(variantsByWidth, function (v) {
    availableHeights.push(parseInt(v.getAttribute('data-height')));
  });

  var closestHeight = closest(xHeight, availableHeights);

  // select variant break
  var sizeVal = closestWidth + 'x' + closestHeight;

  // console.info('looking up a variant for ' + sizeVal);

  // TODO find out how it's possible for a variant to be loaded to the select-options twice : (
  // TODO also deprecate jQuery 'cause it is garbage - use querySelector instead of $.find()[0]
  // $.first() isn't even equivalent to $.find()[0] 'cause of reasons
  let variant = document.querySelector("[data-title='" + sizeVal + "']");

  if (variant) {
    // console.info('variant found:' + variant.getAttribute('data-title'));
    // hasValidSurfaceArea(, , 50);
    document.getElementById('variant-select').value = variant.value;

    // TODO what is this triggering?
    $parentBlock.find('.prodvariant').trigger('change');
  } else {
    console.error('no variant for ' + sizeVal + ' found in the price grid !');
  }

  // validate Headrail
  if (xCat.indexOf('faux wood') > -1 || xCat.indexOf('cordless') > -1) {
    //checkHeadrail();
  }
  //validateControlStyle(xWidth, xHeight);

  //ADDED BY BLUESWITCH TO CHECK FOR CONTROL STYLE.
  var dataElementControl = $(
    '.builderBlock[data-question*="choose control style"]',
  );

  if (dataElementControl) {
    var cElement = $(dataElementControl).find("[data-sku='C']");

    if (xWidth < 25 || xWidth > 75 || xHeight < 24 || xHeight > 72) {
      $(cElement).css('opacity', '0.4');
      $(cElement).css('cursor', 'not-allowed');
      $(cElement).css('pointer-events', 'none');

      if ($('input[name="swatchColor_9"]:checked').val() == '37253286854824') {
        $('input[name=swatchColor_9][value=37253286789288]').prop(
          'checked',
          true,
        );
      }
    } else {
      $(cElement).css('opacity', '1');
      $(cElement).css('cursor', 'allowed');
      $(cElement).css('pointer-events', 'auto');
    }
  }

  // console.info(`Sizing adjusted 2:`);
});

// show hide option based on product type
if ($('.builderWrapper').length > 0) {
  var prodType = $('.builderWrapper').attr('data-type');
  // if wood
  if (prodType.indexOf('wood') > -1) {
    $('.swatchEntry input[title="privacy slats"]').closest('li').hide();
  }
  // mini
  if (prodType.indexOf('mini') > -1) {
    $('.swatchEntry input[title="privacy holes"]').closest('li').hide();
    $('.swatchEntry input[title="cloth tape"]').closest('li').hide();
  }
}

// on change headrail
$('body').on(
  'change',
  '.builderBlock[data-type="headrail"] .variantEntryOpt select',
  function () {
    changeHeadrail();
    //console.log('on change headrail');
  },
);

$('body').on('change', 'select.hro-control-select', forceSplitControl);

function changeHeadrail(requireSplitControl, requireCenterTilt) {
  // console.info(`Changing headrail...`);
  // console.log(
  //   'swatchParentEventTitle to change headrail: ' + swatchParentEventTitle,
  // );

  // hack to avoid changing values unless they need to be changed
  if (
    swatchParentEventTitle != 'choose size' &&
    swatchParentEventTitle != 'choose headrail options'
  ) {
    // console.info('no need to change headrail');
    return false;
  }

  // console.log('changeHeadrail');
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let productJSON = JSON.parse(
    document.getElementById('ProductJson-product-template-builder').innerHTML,
  );

  $('.builderBlock[data-type="headrail"]').addClass('hasEdited');
  var headVarOpt = '';

  var firstVal = $('.builderBlock[data-type="headrail"] .variantEntrySel')
    .first()
    .val();
  if (firstVal === null) {
    var firstValid = $('.builderBlock[data-type="headrail"] .variantEntrySel')
      .first()
      .find('option:not([disabled]):first')
      .attr('value');
    $('.builderBlock[data-type="headrail"] .variantEntrySel')
      .first()
      .val(firstValid);
  }

  $('.builderBlock[data-type="headrail"]')
    .find('.variantEntrySel')
    .each(function (index) {
      //console.log('index:'+index);
      if (index == 0) {
        headVarOpt = headVarOpt + $(this).val().toLowerCase();
      } else {
        headVarOpt = headVarOpt + ' / ' + $(this).val().toLowerCase();
      }
    });
  // console.log('headVarOpt:' + headVarOpt);
  $('.builderBlock[data-type="headrail"]')
    .find('.prodvariant option[data-title="' + headVarOpt + '"]')
    .prop('selected', true);
  $('.builderBlock[data-type="headrail"]')
    .find('.prodvariant')
    .trigger('change');
  //console.log('headVarOpt:'+headVarOpt);
  // if headrail options

  var headVal = $('.builderBlock[data-type="headrail"] .variantEntrySel')
    .first()
    .find('option:selected')
    .attr('title');
  var $hBlock = $('.builderBlock[data-type="headrail"]');
  //console.log('headVal:'+headVal);

  $hBlock.find('.headrail-custom').attr('data-type', headVal);
  if (headVal.indexOf('standard') > -1) {
    // standard headrail options
    $hBlock.find('.control.ctrl-1 select').removeAttr('disabled');
    $hBlock.find('.control.ctrl-2 select').attr('disabled', '');
    var xD = xWidth - Math.floor(xWidth);
    var xDV = '.0';
    // set blind 1 width
    $hBlock.find('#width-crtl-inch-1').val(Math.floor(xWidth));
    if (xD == 0) {
      $hBlock.find('#width-crtl-frac-1').val(xDV);
    } else {
      xDV = xD.toString().replace('0.', '.');
      $hBlock.find('#width-crtl-frac-1').val(xDV);
    }

    // lift chord location validation
    $hBlock.find('#lift-loc-1 option').show();
    $hBlock.find('#lift-loc-2 option').show();

    // TODO clean this up with a switch at minimum
    if (requireSplitControl && $hBlock.find('#lift-loc-1').val() === 'left') {
      $hBlock.find('#tilt-loc-1').val('right');
      $('.headrail-preview .sec-1 .tilt').attr('position', 'right');
    } else if (
      requireSplitControl &&
      $hBlock.find('#lift-loc-1').val() === 'right'
    ) {
      $hBlock.find('#tilt-loc-1').val('left');
      $('.headrail-preview .sec-1 .tilt').attr('position', 'left');
    } else if (requireCenterTilt) {
      $hBlock.find('#lift-loc-1').val('').prop('disabled', true);
    } else if (/Cellular Shades and Blinds/.test(productJSON.type)) {
      $hBlock.find('#tilt-loc-1').val('').prop('disabled', true);
      $hBlock.find('#tilt-loc-2').val('').prop('disabled', true);
      $('.tilt-loc').hide();
    } else {
      $hBlock.find('#lift-loc-1').val('').prop('disabled', false);
      $hBlock.find('#tilt-loc-1').val('left');
      $hBlock.find('#lift-loc-1').val('right');

      // TODO this is probably not correct; need to set position based on inputs ??
      $('.headrail-preview .sec-1 .tilt').attr('position', 'right');
      $('.headrail-preview .sec-2 .tilt').attr('position', 'right');
      $('.headrail-preview .sec-1 .lift').attr('position', 'left');
      $('.headrail-preview .sec-2 .lift').attr('position', 'left');
    }

    $hBlock.find('#lift-loc-2').val('');
    $hBlock.find('#tilt-loc-2').val('');

    // enable privacy hole when standard
    if (swatchParentEventTitle.indexOf('privacy') == -1) {
      if (
        swatchParentEventTitle.indexOf('headrail') > -1 ||
        swatchParentEventTitle.indexOf('size') > -1
      ) {
        changeOption('privacy holes', false);
      }
    }

    if (swatchParentEventTitle.indexOf('choose control') == -1) {
      if (
        swatchParentEventTitle.indexOf('headrail') > -1 ||
        swatchParentEventTitle.indexOf('size') > -1
      ) {
        changeOption('continuous', true);
      }
    }
  }
  if (headVal.indexOf('two') > -1) {
    // two in one headrail options
    $hBlock.find('.control select').removeAttr('disabled');
    var yWidth = xWidth / 2;

    //console.log('yWidth:'+yWidth);
    if (yWidth == Math.floor(yWidth)) {
      // whole number
      // set blind 1 and 2 width
      $hBlock.find('#width-crtl-inch-1').val(Math.floor(yWidth));
      $hBlock.find('#width-crtl-frac-1').val('.0');
      $hBlock.find('#width-crtl-inch-2').val(Math.floor(yWidth));
      $hBlock.find('#width-crtl-frac-2').val('.0');
    } else {
      // decimal number
      var decArr = [0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875];
      var closestDec = null;
      var xD = yWidth - Math.floor(yWidth);

      $.each(decArr, function () {
        if (
          closestDec == null ||
          Math.abs(this - xD) < Math.abs(closestDec - xD)
        ) {
          closestDec = this;
        }
      });

      // set blind 1 and 2 width
      $hBlock.find('#width-crtl-inch-1').val(Math.floor(yWidth));
      $hBlock
        .find('#width-crtl-frac-1')
        .val(closestDec.toString().replace('0.', '.'));
      $hBlock.find('#width-crtl-inch-2').val(Math.floor(yWidth));
      $hBlock
        .find('#width-crtl-frac-2')
        .val(closestDec.toString().replace('0.', '.'));
    }
    // lift chord location validation
    $hBlock.find('#tilt-loc-1').val('left');
    $hBlock.find('#tilt-loc-2').val('right');
    $hBlock.find('#lift-loc-1').val('left');
    $hBlock.find('#lift-loc-2').val('right');

    // position lift and tilt
    $('.headrail-preview .sec-1 .tilt').attr('position', 'left');
    $('.headrail-preview .sec-2 .tilt').attr('position', 'right');
    $('.headrail-preview .sec-1 .lift').attr('position', 'left');
    $('.headrail-preview .sec-2 .lift').attr('position', 'right');

    // console.log('swatchParentEventTitle:' + swatchParentEventTitle);
    if (swatchParentEventTitle.indexOf('privacy') == -1) {
      if (
        swatchParentEventTitle.indexOf('headrail') > -1 ||
        swatchParentEventTitle.indexOf('size') > -1
      ) {
        changeOption('privacy holes', true);
      }
    }

    // enable continous loop
    //$('.builderBlock[data-question*="choose control"] input[title*="continuous cord loop"]').prop("disabled", false).prop("checked", false);
  }

  // end if headrail options
  //checkCellularShades(xWidth, xHeight);
  updateHeadrailSKU();

  //ADDED BY BLUESWITCH TO DISABLE PRIVACY SLAT WITH 2-ON-1 OPTION
  //first check if the tag to disable 2 on 1 is activated.
  if (productJSON.tags.indexOf('Disable: PS 2-on-1') > -1) {
    //check if headval is selected to two. disable privacy slat option. /else enable.
    if (headVal.indexOf('two') > -1) {
      $('.privacy-slat').css('opacity', '0.4');
      $('.privacy-slat input').prop('disabled', true);

      //disable tilt/liftcord options
      $('#tilt-loc-1').prop('disabled', true);
      $('#lift-loc-1').prop('disabled', true);

      //disable tilt/liftcord options
      $('#tilt-loc-2').prop('disabled', true);
      $('#lift-loc-2').prop('disabled', true);
    } else {
      $('.privacy-slat').css('opacity', '1');
      $('.privacy-slat input').prop('disabled', false);

      //disable tilt/liftcord options
      $('#tilt-loc-1').prop('disabled', false);
      $('#lift-loc-1').prop('disabled', false);

      //disable tilt/liftcord options
      $('#tilt-loc-2').prop('disabled', false);
      $('#lift-loc-2').prop('disabled', false);
    }

    //check if privacy slats are already selected.
    var dataElement = $(
      '.builderBlock[data-question*="choose privacy options"]',
    );
    if ($(dataElement).attr('data-price') > 0) {
      $('.variantEntrySel option[value="Two on One Headrail"]').prop(
        'disabled',
        true,
      );
    } else {
      // $('.variantEntrySel option[value="Two on One Headrail"]').prop('disabled',false);
    }
  }
}

// change tilt location
$('body').on('change', '.tilt-loc select', function () {
  // console.info(`Changing tilt location...`);
  var xSectionID = $(this).attr('id');
  var xTiltVal = $(this).val();
  if (xSectionID == 'tilt-loc-1') {
    $('.headrail-preview .sec-1 .tilt').attr('position', xTiltVal);
  } else if (xSectionID == 'tilt-loc-2') {
    $('.headrail-preview .sec-2 .tilt').attr('position', xTiltVal);
  }
  updateHeadrailSKU();
});

// change lift location
$('body').on('change', '.lift-loc select', function () {
  // console.info(`Changing lift location...`);
  var xSectionID = $(this).attr('id');
  var xLiftVal = $(this).val();

  if (xSectionID == 'lift-loc-1') {
    $('.headrail-preview .sec-1 .lift').attr('position', xLiftVal);
  } else if (xSectionID == 'lift-loc-2') {
    $('.headrail-preview .sec-2 .lift').attr('position', xLiftVal);
  }
  updateHeadrailSKU();
});

//  headrail blind size select
$('body').on('change', '.blind-size select', function () {
  // console.info(`Changing on blind-size select...`);
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );

  yWidthVal_1 =
    $('#width-crtl-inch-1').not(':disabled').val() +
    $('#width-crtl-frac-1').not(':disabled').val();
  yWidthVal_2 =
    $('#width-crtl-inch-2').not(':disabled').val() +
    $('#width-crtl-frac-2').not(':disabled').val();
  if (isNaN(yWidthVal_1)) {
    yWidthVal_1 = 0;
  }
  if (isNaN(yWidthVal_2)) {
    yWidthVal_2 = 0;
  }
  $('#headrail-specs .control.ctrl-1')
    .attr('data-width', yWidthVal_1)
    .attr('data-total-width', xWidth);
  $('#headrail-specs .control.ctrl-2')
    .attr('data-width', yWidthVal_2)
    .attr('data-total-width', xWidth);

  var errorWidth = '';
  var bWidth_1 = parseFloat($('.control.ctrl-1').attr('data-width'));
  var bWidth_2 = parseFloat($('.control.ctrl-2').attr('data-width'));
  var bWidth_Total = bWidth_1 + bWidth_2;

  //console.log('xWidth:'+parseFloat(xWidth).toFixed(3));
  //console.log('bWidth_Total:'+bWidth_Total.toFixed(3));

  if (bWidth_Total.toFixed(3) != parseFloat(xWidth).toFixed(3)) {
    var bWidth_TotalDecimal = bWidth_Total - Math.floor(bWidth_Total);
    var bWidth_TotalFraction = decimalToFraction(bWidth_TotalDecimal);

    var bWidth_Decimal = xWidth - Math.floor(xWidth);
    var bWidth_Fraction = decimalToFraction(bWidth_Decimal);

    //console.log('xWidth:' + xWidth);
    //console.log('bWidth_Decimal:' + bWidth_Fraction);

    var bWidth_Text = $.trim(Math.floor(xWidth) + ' ' + bWidth_Fraction);
    var bWidth_TotalText = $.trim(
      Math.floor(bWidth_Total) + ' ' + bWidth_TotalFraction,
    );

    errorWidth =
      'Please check your width values.  Required total width is ' +
      bWidth_Text +
      ' inches but your split values add up to ' +
      bWidth_TotalText +
      ' inches.';
  }
  if (errorWidth != '') {
    $('#headrail-rule-message').show();
    $('#headrail-rule-message .variantNoticeBox').show();
    $('#headrail-rule-message .variantNoticeSelection').html(errorWidth);
    $('.builder__cart-btn').prop('disabled', true);
  } else {
    $('#headrail-rule-message').hide();
    $('#headrail-rule-message .variantNoticeBox').hide();
    $('.builder__cart-btn').prop('disabled', false);
  }
});

// change notes
// $('body').on('change', '.optionalNotes', function() {
//     $(this).closest('.builderBlock').addClass('hasEdited');
//     var notesProp = '';
//     var notesIndex = 0;
//     $(this).closest('.parentBlock').find('.optionalNotes').each(function() {
//         var thisProp = $(this).attr('data-prop');
//         var thisVal = $(this).val();
//         if (thisVal != '') {
//             if (notesIndex == 0) {
//                 notesProp = notesProp + thisProp + ': ' + thisVal;
//             } else {
//                 notesProp = notesProp + ', ' + thisProp + ': ' + thisVal;
//             }
//             notesIndex += 1;
//         }
//     });
//     $(this).closest('.parentBlock').find('[data-property]').val(notesProp).trigger('change');
// });

// change order qty
$('body').on('change', '#builderQty', function () {
  // console.info(`Adjusting quantity:`);
  trackAdjustQuantity(productData, parseInt($(this).val()), 'product-builder');
  productData.previousQuantity = parseInt($(this).val());
  getTotal();
});

$('body').on(
  'change',
  '.builderBlock[data-type="headrail"] select',
  function () {
    setHeadRailProp();
  },
);

$('body').on('change', '[data-property]', function () {
  // console.info(`data-property build-summary:`);
  console.info('updating chosen option display...');

  var chosenOption = $(this).closest('.builder-step input')[0].value;

  var el = $(this).closest('.builder-step input')[0];

  chosenOption = chosenOption.replace('undefined', '');

  if (chosenOption.includes('Inside Mount')) {
    $(el).closest('.builder-step').find('.chosen-option').html('Inside Mount');
  } else if (chosenOption.includes('Outside Mount')) {
    $(el).closest('.builder-step').find('.chosen-option').html('Outside Mount');
  } else {
    $(el).closest('.builder-step').find('.chosen-option').html(chosenOption);
  }

  // buildSummary();
});

// on change block variant
$('body').on('change', '.prodvariant', function () {
  // console.info(`Changing .prodvariant:`);
  let blockPrice = 0,
    compPrice = 0;
  $(this)
    .find('option:selected')
    .each(function () {
      blockPrice =
        blockPrice + parseFloat($(this).attr('data-price').replace(',', ''));
      compPrice =
        compPrice + parseFloat($(this).attr('data-compare').replace(',', ''));
    });

  // console.info('updating chosen price: ' + blockPrice);
  var variantNotice = $(this).find('option:selected').attr('data-notice');
  $(this).closest('.parentBlock').attr('data-price', blockPrice);
  $(this).closest('.parentBlock').attr('data-compare', compPrice);
  //console.log(variantNotice);
  if (variantNotice != undefined) {
    if (variantNotice != '') {
      $(this)
        .closest('.builderBlock')
        .find('.variantNoticeBox')
        .show()
        .find('.variantNoticeSelection')
        .html(variantNotice);
    } else {
      $(this)
        .closest('.builderBlock')
        .find('.variantNoticeBox')
        .hide()
        .find('.variantNoticeSelection')
        .html('');
    }
  } else {
    $(this)
      .closest('.builderBlock')
      .find('.variantNoticeBox')
      .hide()
      .find('.variantNoticeSelection')
      .html('');
  }
  //console.log('change me:'+ xWidth);

  // adjust fold
  // var headrailVal = $('select[data-prop*="headrail options"] option:selected').attr('data-title');
  // var mountVal = $('select[data-prop*="mount"] option:selected').attr('data-title');
  // //console.log('mountVal:'+mountVal);
  // if (headrailVal == 'standard headrail') {
  //   if (xWidth >= 30 && mountVal == 'outside mount') {
  //     $('.builderBlock[data-question*="fold "] input[title*="european"]').prop("disabled", false);
  //   } else {
  //     $('.builderBlock[data-question*="fold "] input[title*="european"]').prop("disabled", true).prop("checked", false);
  //   }
  // } else {
  //   if (xWidth >= 48 && mountVal == 'outside mount') {
  //     $('.builderBlock[data-question*="fold "] input[title*="european"]').prop("disabled", false);
  //   } else {
  //     $('.builderBlock[data-question*="fold "] input[title*="european"]').prop("disabled", true).prop("checked", false);
  //   }
  // }
  //var cCheckedTitle = $(this).closest('.builderBlock').find('.swatchEntry input:checked').attr('title').toLowerCase();

  getTotal();
});
var swatchParentEventTitle = '';

$('body').on('click', '.swatchEntry input', function (e) {
  swatchParentEventTitle = $(this)
    .closest('.builderBlock')
    .attr('data-question');
});

$('body').on('click', '#product-description-show-more', function (e) {
  e.preventDefault();
  $('#product-description').css('-webkit-mask-image', 'none');

  $('#product-description').animate(
    {
      height: $('#product-description').get(0).scrollHeight,
    },
    1000,
    function () {
      $(this).height('auto');
    },
  );

  $('#product-description-show-more').hide();
  $('#product-description-show-less').show();
});

$('body').on('click', '#product-description-show-less', function (e) {
  e.preventDefault();
  $('#product-description').css(
    '-webkit-mask-image',
    'linear-gradient(to bottom,rgba(0,0,0,1) 60%,rgba(0,0,0,0))',
  );
  $('#product-description').animate({ height: 300 }, 200);

  $('#product-description-show-more').show();
  $('#product-description-show-less').hide();
});

$('body').on('change', '.swatchEntry input', function (e) {
  ruleCheck();
});
$('body').on('change', '.sizeEntry select', function () {
  // console.info(`sizeEntry select:`);
  swatchParentEventTitle = $(this)
    .closest('.builderBlock')
    .attr('data-question');
  ruleCheck();
});
$('body').on('change', '.variantEntrySel', function () {
  // console.info(`Changing variantEntrySel:`);
  swatchParentEventTitle = $(this)
    .closest('.builderBlock')
    .attr('data-question');
  ruleCheck();
});

// on change property
$('body').on('change', '[data-property][required]', function () {
  // console.info(`Changing data-property required:`);
  var isValidated = $('.builderWrapper').hasClass('userValidated');
  if (isValidated) {
    checkRequired(isValidated);
  }
  getTotal();
});

// trigger variant change to update price
// TODO this script doesn't need to be included on every page !
$('document').ready(function () {
  // TODO for now, just add a guard
  if (document.querySelector('.builderBlock')) {
    $('.builderBlock[data-type="size"] .sizeEntry.height .parentSize').trigger(
      'change',
    );

    $(
      '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] select',
    ).trigger('change');
  }

  previousQuantity = $('#builderQty').val();
});

// add to cart function
// TODO GTM track addToCart
$('body').on('click', '.submitBuilder', function () {
  // console.info(`Clicked submitBuilder:`);

  // if (hasValidSurfaceArea()) {
  //   return false;
  // }

  $('.builderWrapper').addClass('userValidated');
  checkRequired();
  if ($('.builderBlock.blockError').length > 0) {
  } else {
    // no error found
    $('body').addClass('buildingCart');
    buildBundle();
  }
});

// update builder
$('body').on('click', '.updateBuilder', function () {
  console.info(`Updating builder...`);
  $('.builderWrapper').addClass('userValidated');
  checkRequired();
  if ($('.builderBlock.blockError').length > 0) {
  } else {
    // no error found
    $('body').addClass('buildingCart');
    // remove items and build new bundle
    if (getQueryParams(document.location.search).view == 'edit') {
      var bundleTS = getQueryParams(document.location.search).ts;
      // console.log('bundleTS:' + bundleTS);
      $.ajaxSetup({
        async: false,
      });
      $('.cartInfo li[data-time="' + bundleTS + '"]').each(function () {
        var xID = $(this).attr('data-key');
        jQuery.post('/cart/change.js', {
          id: xID,
          quantity: 0,
        });
        // console.log('remove:' + xID);
      });
      $.ajaxSetup({
        async: true,
      });
      buildBundle();
    }
  }
});
//
//jQuery.post('/cart/change.js', {'line': 1,'quantity': 0});

// cart page
// TODO document
$('body').on('click', '[data-edit] a', function () {
  var bundleTS = $(this).closest('[data-time]').attr('data-time');
  document.location.href = $(this).attr('href');

  return false;
});

// change bundle qty update child quantity
// TODO add spinner
$('body').on('change', '.bundleQty', function () {
  // console.info(`Changing bundle quantity:`);
  var qTS = $(this).closest('tr').attr('data-time');
  var qVal = $(this).val();
  $('.cart__row[data-time="' + qTS + '"] .bundleQty').val(qVal);
  let $productRow = $(this).closest('tr');
  let lineItemData = {
    title: $productRow.attr('data-product-title'),
    id: $productRow.attr('data-variant-sku'),
    price: $productRow.attr('data-price') / 100,
    sku: $productRow.attr('data-variant-sku'),
    vendor: $productRow.attr('data-product-vendor'),
    previousQuantity: parseInt($productRow.attr('data-previous-quantity')),
  };

  trackAdjustQuantity(lineItemData, parseInt(qVal), 'cart');

  $('input[name="update"]').trigger('click');
});

// remove bundle
// TODO convert to async / await, add spinner
// TODO research mobile issues with bundled items display during quantity increase
$('body').on('click', '.removeBundleCart', function () {
  // console.info(`Clicked removeBundleCart:`);
  var qTS = $(this).closest('tr').attr('data-time');
  let bundle = $(this).closest('tr').attr('data-cart-item-title');
  // console.info(`Got bundle cart item ${bundle} with timestamp ${qTS}.`);

  // TODO research as to whether this is still necessary
  var qVal = $(this).val();
  $('.cart__row[data-time="' + qTS + '"] .bundleQty').val(0);

  let $productRow = $(this).closest('tr');
  let lineItemData = {
    name: $productRow.attr('data-product-title'),
    id: $productRow.attr('data-variant-sku'),
    price: $productRow.attr('data-price') / 100,
    sku: $productRow.attr('data-variant-sku'),
    vendor: $productRow.attr('data-product-vendor'),
    previousQuantity: parseInt($productRow.attr('data-previous-quantity')),
  };

  // console.info(`Removing item ${lineItemData.name}`);
  trackAdjustQuantity(lineItemData, 0, 'cart');

  // pulled from removeCartConfirm due to issues with setting qty to 0 -> triggering click
  $.ajaxSetup({
    async: false,
  });
  $('.cart__row[data-time="' + qTS + '"]').each(function () {
    var xID = $(this).attr('data-cart-item-key');
    let title = $(this).attr('data-cart-item-title');
    // console.info(`Found ${title} / key ${xID}, removing...`);

    jQuery.post('/cart/change.js', {
      id: xID,
      quantity: 0,
    });

    // console.info(`Removed ${title} / key ${xID}.`);
  });
  $.ajaxSetup({
    async: true,
  });

  // TODO research as to whether this is still necessary
  $('input[name="update"]').trigger('click');
  return false;
});

// TODO what is all this accomplishing?  need better documentation
$('.cart__row[data-time]').each(function () {
  var cartTS = $(this).attr('data-time');
  var parentCount = $(
    '.cart__row[data-time="' + cartTS + '"][data-bundle="Parent"]',
  ).length;
  var editUrl =
    '/products/' +
    $(this).attr('data-bundle-handle') +
    '?view=edit&ts=' +
    cartTS;

  // no parent found
  if (parentCount == 0) {
    // console.log('parent Count issue timeStamp:' + cartTS);
    removeCartConfirm(cartTS, editUrl, errorTitle, bundleErrorMsg);

    return false;
  }
  // is parent find child count
  if ($(this).attr('data-bundle') == 'Parent') {
    var bundleArr = $(this).attr('data-bundle-id').split(', ');
    var bundleArrCount = 0;

    $('.cart__row[data-time="' + cartTS + '"').each(function () {
      bundleArrCount += 1;
    });
    //console.log('bundleArrSize:'+bundleArr.length);
    //console.log('bundleArrCount:'+bundleArrCount);

    // child count dont match
    if (bundleArr.length != bundleArrCount) {
      // console.log('child Count issue');
      removeCartConfirm(cartTS, editUrl, errorTitle, bundleErrorMsg);
      return false;
    }
  }
});

$('body').on('click', '.js-qty__adjust', function () {
  // console.info(`Clicked js-qty__adjust:`);
  var xQty = $(this).closest('.js-qty').find('.js-qty__num');
  var xQtyVal = parseInt(xQty.val());
  if ($(this).hasClass('js-qty__adjust--minus')) {
    if (xQtyVal == 1) {
    } else {
      xQty.val(xQtyVal - 1);
    }
  }
  if ($(this).hasClass('js-qty__adjust--plus')) {
    xQty.val(xQtyVal + 1);
  }

  xQty.trigger('change');
});

$('body').on('click', '.scrollCustomize', function () {
  // console.info(`Clicked customize:`);
  $('html, body').animate(
    {
      scrollTop:
        $('.builderWrapper ').offset().top -
        $('.drawer__header-container').outerHeight(),
    },
    300,
  );
});

// only show remote control when classic motorization  is chosen
$('body').on('change', '[data-property]', function () {
  console.info(`showing remote control option...`);

  var chosenOption = $(this).closest('.builder-step input')[0].value;

  // TODO hotfix, cleanup
  if (chosenOption.includes('Motorized')) {
    $('.builderBlock[data-question*="remote control"]').show();
    $('.builderBlock[data-question*="remote control"] .builder-option').show();
  } else if (
    chosenOption.includes('Motorwand') ||
    chosenOption.includes('Top Down') ||
    chosenOption.includes('Continuous Cord') ||
    chosenOption.includes('Cordless') ||
    chosenOption.includes('Beaded Chain')
  ) {
    $('.builderBlock[data-question*="remote control"]').hide();
    $('.builderBlock[data-question*="remote control"] .builder-option').hide();
  }
});

// TODO document this
$('.variantEntrySel[data-prop="tilt type"] option[title="cord"]').attr(
  'data-sku',
  'C',
);

// TODO document this
$('.variantEntrySel[data-prop="tilt type"] option[title="wand"]').attr(
  'data-sku',
  'W',
);

//hide variant
var hiddenVariant = $.trim($('.builderWrapper').attr('data-hidden-variant'));
if (hiddenVariant != '') {
  var hiddenVariantArr = hiddenVariant.split(', ');
  $.each(hiddenVariantArr, function (key, value) {
    $('.swatchEntry input[title="' + value + '"]')
      .closest('li')
      .hide();
  });
}

// see: https://stackoverflow.com/questions/62527556/round-off-number-to-the-nearest-highest-number-from-array-in-javascript
function closest(needle, haystack) {
  // note use of greaterthan here
  return haystack
    .sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    })
    .find((numb) => numb >= needle);
}

function getQueryParams(qs) {
  qs = qs.split('+').join(' ');
  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params;
}

function unique(list) {
  var result = [];
  $.each(list, function (i, e) {
    if ($.inArray(e, result) == -1) result.push(e);
  });
  return result;
}
function ruleCheck() {
  // console.info('Rule check:');
  // console.log('ruleCheck:' + xCat);
  let productJSON = JSON.parse(
    document.getElementById('ProductJson-product-template-builder').innerHTML,
  );

  if ($('.parentSize').first().find('option').last().prop('selected')) {
  }

  var productName = $('.builderWrapper h2').text();

  if (/Hardwood Cordless/.test(productName)) {
    $('#lift-loc-1').prop('disabled', true);
    $('#lift-loc-2').prop('disabled', true);
    $('#lift-loc-1').closest('div').hide();
    $('#lift-loc-2').closest('div').hide();
  }

  if (
    xCat.indexOf('faux wood') > -1 ||
    xCat.indexOf('cordless') > -1 ||
    xCat.indexOf('wood blind') > -1 ||
    xCat.indexOf('hardwood blinds') > -1
  ) {
    if ($('.builderBlock[data-type="headrail"]').length > 0) {
      checkHeadrail();
    }
    checkPrivacyCloth(productName);
    checkPrivacySlats(productName);
    checkValanceOptions();
    checkClothTape();
  }
  if (xCat.indexOf('cellular shades') > -1) {
    if ($('.builderBlock[data-type="headrail"]').length > 0) {
      checkHeadrail();
    }
    checkCellularShades();
  }
  if (xCat.indexOf('roman shades') > -1) {
    checkRomanShades();
  }
  if (xCat.indexOf('roller shades') > -1) {
    checkRollerShades(productName);
    checkCassetteValance();
  }
  if (xCat.indexOf('vertical blind') > -1) {
    checkVerticalBlinds();
  }
  if (xCat.indexOf('mini blind') > -1) {
    if ($('.builderBlock[data-type="headrail"]').length > 0) {
      checkHeadrail();
    }

    checkPrivacySlats(productName);
    checkPrivacyCloth(productName);
  }
  if (xCat.indexOf('zebra') > -1) {
    checkZebraShades();
  }
  if (xCat.indexOf('woven') > -1) {
    checkWovenShades();
  }

  //ADDED BY BLUESWITCH TO CHECK VALANCE OPTIONS
  checkValanceMounting();
}

function forceSplitControl() {
  let productJSON = JSON.parse(
    document.getElementById('ProductJson-product-template-builder').innerHTML,
  );

  if (productJSON.tags.includes('Undersize Split Controls')) {
    let xWidth = parseFloat(
      $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
    );
    let tilt = $('#tilt-loc-1').val();
    if (xWidth <= 18) {
      let dependent =
        event.target.id === 'tilt-loc-1' ? '#lift-loc-1' : '#tilt-loc-1';

      // force lift to depend on tilt
      // jquery gross
      let newValue =
        $('#' + event.target.id).val() === 'left' ? 'right' : 'left';
      $(dependent).val(newValue);
      // TODO show / hide messaging?  or is handled elsewhere?
    }
  }
}

function checkPrivacySlats(productName) {
  // TODO store the chosen privacy option at the component level and then re-render based on width change
  // and (clear the chosen privacy option where necessary)
  let xCat = $('.builderWrapper').attr('data-type');
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );

  // TODO more grossness
  if (
    (/faux wood/.test(xCat) &&
      (/Premier/.test(productName) || /Signature/.test(productName))) ||
    /Hardwood Horizontal/.test(productName)
  ) {
    // TODO clear selected option
    if (xWidth <= 60) {
      $('.swatchEntry [data-sku="ps-12-60"]').show();
      $('.swatchEntry [data-sku="ps-61-120"]').hide();
    } else {
      $('.swatchEntry [data-sku="ps-12-60"]').hide();
      $('.swatchEntry [data-sku="ps-61-120"]').show();
    }
  } else {
    // TODO clear selected option
    // TODO not every product here would have privacy slats; lazy coding here
    if (xWidth <= 60) {
      $('.swatchEntry [data-sku="ps-13-60"]').show();
      $('.swatchEntry [data-sku="ps-61-126"]').hide();
    } else {
      $('.swatchEntry [data-sku="ps-13-60"]').hide();
      $('.swatchEntry [data-sku="ps-61-126"]').show();
    }
  }
}

function checkPrivacyCloth(productName) {
  // TODO store the chosen privacy option at the component level and then re-render based on width change
  // and (clear the chosen privacy option where necessary)
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $('.builder').find('.sizeEntry.height[data-size]').attr('data-size'),
  );

  // TODO this is gross

  // 2" premier faux wood, 2" signature faux wood
  // Cloth Tape up to 60x96, Cloth Tape over 61x96
  // ct-12-60, ct-61-126
  if (/Premier/.test(productName) || /Signature/.test(productName)) {
    if (xWidth <= 60) {
      $('.swatchEntry [data-sku="ct-12-60"]').show();
      $('.swatchEntry [data-sku="ct-61-126"]').hide();
    } else {
      $('.swatchEntry [data-sku="ct-12-60"]').hide();
      $('.swatchEntry [data-sku="ct-61-126"]').show();
    }
  } else if (/Aluminum Horizontal Blind/.test(productName)) {
    // 2" aluminum horizontal
    // TODO clear selected option?
    if (xWidth <= 60) {
      $('.swatchEntry [data-sku="ct-9-60"]').show();
      $('.swatchEntry [data-sku="ct-61-96"]').hide();
    } else {
      $('.swatchEntry [data-sku="ct-9-60"]').hide();
      $('.swatchEntry [data-sku="ct-61-96"]').show();
    }
  }
}

function getTotal() {
  var blockPrice = 0;
  var comparePrice = 0;
  $('.builderBlock.parentBlock').each(function () {
    blockPrice += parseFloat($(this).attr('data-price'));
    comparePrice += parseFloat($(this).attr('data-compare'));
  });
  $('.builderSubTotal').text(blockPrice.toFixed(2));
  $('.compareSubTotal').text(comparePrice.toFixed(2));
  if (comparePrice > blockPrice) {
    $('body').addClass('showCompare');
  } else {
    $('body').removeClass('showCompare');
  }

  var bQty = $('#builderQty').val();
  var builderTotal = blockPrice * bQty;
  var compBuilderTotal = comparePrice * bQty;

  $('.builderTotal').text(builderTotal.toFixed(2));
  $('.compBuilderTotal').text(compBuilderTotal.toFixed(2));
}

// NOTE one-off event tracking due to impossibility of tying into a single event
$('select[data-prop="headrail options"]').on('focusout', function () {
  let choice = $('.builderBlock[data-type="headrail"] .variantEntrySel')
    .first()
    .find('option:selected')
    .attr('title');

  trackProductConfig(productData, 'headrail options', choice);
});

$('select.parentSize').on('focusout', function () {
  let parentSize = $(this).val();
  let subSize = $(this).closest('.sizeEntry').find('.subSize').val();

  var sizeSel = parentSize + subSize;

  trackProductConfig(productData, 'choose size', sizeSel);
});

$('select.subSize').on('focusout', function () {
  let parentSize = $(this).closest('.sizeEntry').find('.parentSize').val();
  let subSize = $(this).val();

  var sizeSel = parentSize + subSize;

  trackProductConfig(productData, 'choose size', sizeSel);
});

// used for cordless hardwoods but could be reused elsewhere
// function hasValidSurfaceArea(width, height, maximumSize) {
//   const size = width * height * 0.00694444;
//   if (size > maximumSize) {
//     // TODO may need new separate error container
//     $('.builderBlock[data-type="size"] .variantNoticeSelection').append(
//       `<br/><b>This blind may only have a maximum total area of ${maximumSize} sqft.; please decrease dimensions.</b>`,
//     );
//     return false;
//   } else {
//     // TODO probably not safe
//     $('.builderBlock[data-type="size"] .variantNoticeSelection').empty();
//     return true;
//   }
// }

function checkHeadrail() {
  // console.log(
  //   'swatchParentEventTitle to change headrail: ' + swatchParentEventTitle,
  // );

  if (
    swatchParentEventTitle != 'choose size' &&
    swatchParentEventTitle != 'choose headrail options'
  ) {
    // console.info('no need to change headrail');
  }
  // TODO improve this via a configuration object
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $('.builder').find('.sizeEntry.height[data-size]').attr('data-size'),
  );
  let productJSON = JSON.parse(
    document.getElementById('ProductJson-product-template-builder').innerHTML,
  );

  let requireSplitControl = false,
    requireCenterTilt = false;

  var headrailOpt = $(
    '.builderBlock[data-type="headrail"] .variantEntrySel option:selected',
  ).attr('title');
  // console.log('checkHeadrail:' + xWidth);

  var msg = '';
  // mini blinds cat id
  var miniSet1in = [65, 66];
  if ($('.builderBlock[data-type="headrail"]').length) {
    if (/Hardwood Cordless/.test(productJSON.title) && xWidth > 84) {
      msg =
        '<span>The size you have chosen is unavaiable as a one piece blind.  Sizes over 84" must be made as a 2 on 1 head rail.</span>';

      // console.info(msg);
      $(
        '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
      )
        .eq(0)
        .prop('disabled', true);
    } else if (xWidth > 96) {
      msg =
        '<span>The size you have chosen is unavaiable as a one piece blind.  Sizes over 96" must be made as a 2 on 1 head rail.</span>';

      // console.info(msg);
      $(
        '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
      )
        .eq(0)
        .prop('disabled', true);
    } else if (
      productJSON.tags.includes('Undersize Split Controls') &&
      xWidth <= 18
    ) {
      // console.log('xWidth:' + xWidth);

      msg =
        '<span>Blinds with a width of 18" and under must have split controls.</span>';
      // console.info(msg);
      $(
        '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
      )
        .eq(1)
        .prop('disabled', true);
      $(
        '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
      )
        .eq(0)
        .prop('disabled', false);

      // later validates width and adjusts second control according to first width selection
      // TODO fire forceSplitControl here - right now the event management is incorrect
      requireSplitControl = true;
    } else {
      msg = '';
      // console.info('Message cleared 1');
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(0)
        .prop('disabled', false);
    }

    if (xWidth < 24) {
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(1)
        .prop('disabled', true);
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(2)
        .prop('disabled', true);
    } else if (xWidth < 36) {
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(1)
        .prop('disabled', false);
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(2)
        .prop('disabled', true);
    } else {
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(1)
        .prop('disabled', false);
      $('.builderBlock[data-type="headrail"] .variantEntrySel')
        .first()
        .find('option')
        .eq(2)
        .prop('disabled', false);
    }

    if (
      $('.builderWrapper h2').text().indexOf('Aluminum Horizontal Blind') > -1
    ) {
      if (xWidth <= 11) {
        msg =
          '<span>Blinds with a width of 11" and under must have a center tilt mechanism with no lift.</span>';
        // console.info(msg);

        // TODO force center tilt
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(1)
          .prop('disabled', true);
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(0)
          .prop('disabled', false);

        requireCenterTilt = true;
        // console.info('center tilt required');
      } else if (xWidth < 15 && xWidth >= 11) {
        msg =
          '<span>Blinds with a width between 11⅛" and 15" must have split controls (left / right or right / left)).</span>';
        // console.info(msg);

        // TODO force split control
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(1)
          .prop('disabled', false);
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(0)
          .prop('disabled', false);

        // console.info('split control required');
      } else {
        msg = '';
        // console.info('Message cleared 3');
        $('.builderBlock[data-type="headrail"] .variantEntrySel')
          .first()
          .find('option')
          .eq(0)
          .prop('disabled', false);
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(1)
          .prop('disabled', false);
      }
    }
  }
  if (msg != '') {
    $('.variantNoticeBox-headrail').show().find('.alert__info').html(msg);
  } else {
    $('.variantNoticeBox-headrail').hide().find('.alert__info').html(msg);
  }

  //ADDED BY BLUESWITCH TO DISABLE PRIVACY SLAT WITH 2-ON-1 OPTION
  if (
    swatchParentEventTitle == 'choose privacy options' &&
    productJSON.tags.indexOf('Disable: PS 2-on-1') > -1
  ) {
    var dataElement = $(
      '.builderBlock[data-question*="choose privacy options"]',
    );

    if ($(dataElement).attr('data-price') > 0) {
      $('.variantEntrySel option[value="Two on One Headrail"]').prop(
        'disabled',
        true,
      );
    } else {
      ///  $('.variantEntrySel option[value="Two on One Headrail"]').prop('disabled',false);
    }
  }

  changeHeadrail(requireSplitControl, requireCenterTilt);
}

function checkValanceOptions() {
  //$('.builderBlock.parentBlock[data-question*="valance"] .prodvariant').val('');
  //$('.builderBlock[data-question*="valance"] [data-property]').val('');
  //$('.builderBlock.parentBlock[data-question*="valance"]').find('.swatchEntry input').prop('disabled', false ).prop('checked', false );

  if ($('input[title="inside mount"]:checked').length > 0) {
    // inside
    // hide outside valance
    $('.builderBlock.parentBlock[data-question*="valance"]')
      .find('.swatchEntry input[title*="outside"]')
      .prop('disabled', true)
      .prop('checked', false);
    $('.builderBlock.parentBlock[data-question*="valance"]')
      .find('.swatchEntry input[title*="inside"]')
      .prop('disabled', false);
  } else if ($('input[title="outside mount"]:checked').length > 0) {
    // outside
    // hide inside valance
    $('.builderBlock.parentBlock[data-question*="valance"]')
      .find('.swatchEntry input[title*="inside"]')
      .prop('disabled', true)
      .prop('checked', false);
    $('.builderBlock.parentBlock[data-question*="valance"]')
      .find('.swatchEntry input[title*="outside"]')
      .prop('disabled', false);
  }
}

function checkClothTape() {
  //ADDED BY BS - CHANCED TO CLASS INSTEAD OF TITLE.
  if ($('input.cloth-tape:checked').length > 0) {
    $('.builderBlock[data-question*="privacy cloth"]').show();
    $('.builderBlock[data-question*="privacy cloth"] .prodvariant')
      .attr('data-add', true)
      .prop('required', true);
    $('.builderBlock[data-question*="privacy cloth"] [data-property]').prop(
      'required',
      true,
    );
  } else {
    $('.builderBlock[data-question*="privacy cloth"]').hide();
    $('.builderBlock[data-question*="privacy cloth"] .prodvariant')
      .attr('data-add', false)
      .prop('required', false);
    $('.builderBlock[data-question*="privacy cloth"] [data-property]').prop(
      'required',
      false,
    );
    $('.builderBlock[data-question*="privacy cloth"] .errorMsg').remove();

    $('.builderBlock[data-question*="privacy cloth"] .swatchEntry input').prop(
      'checked',
      false,
    );
    $('.builderBlock[data-question*="privacy cloth"] .prodvariant').val('');
    $('.builderBlock[data-question*="privacy cloth"] [data-property]').val('');
  }
}

function validateControlStyle(xWidth, xHeight) {
  var yWidth = parseFloat(xWidth);
  var yHeight = parseFloat(xHeight);
  var xNotice =
    'All roller shades measuring less than 15" or more than 73" wide must be Chain Roller (Continuous Cord Loop)';
  var targetBlock = $(
    '.builderWrapper[data-type*="roller shades"] .builderBlock[data-question*="choose control"]',
  );

  targetBlock.find('.prodvariant').val('');
  targetBlock.find('[data-property]').val('');
  targetBlock
    .find('.swatchEntry input')
    .prop('disabled', false)
    .prop('checked', false);

  // roller shades
  if ($('.builderWrapper[data-type*="roller shades"]').length > 0) {
    if (yWidth > 75 || yWidth < 15) {
      targetBlock
        .find('.variantNoticeBox')
        .show()
        .find('.variantNoticeSelection')
        .html(xNotice);
      targetBlock
        .find('.swatchEntry input[title*="cordless"]')
        .prop('disabled', true);
    } else {
      targetBlock
        .find('.variantNoticeBox')
        .hide()
        .find('.variantNoticeSelection')
        .html('');
      targetBlock
        .find('.swatchEntry input[title*="cordless"]')
        .prop('disabled', false);
    }
  }
  //console.log('yWidth:'+yWidth);
  //console.log('yHeight:'+yHeight);

  // // roman shades
  // if ($('.builderWrapper[data-type*="roman shades"]').length > 0) {
  //   xNotice = 'Continuous Cord Loop is not available with Roman shades measuring less than 24" wide or more than 120" tall';
  //   targetBlock = $('.builderWrapper[data-type*="roman shades"] .builderBlock[data-question*="choose control"]');
  //   if (yHeight > 120 || yWidth < 24) {
  //     //console.log('err cont');
  //     targetBlock.find('.variantNoticeBox').show().find('.variantNoticeSelection').html(xNotice);
  //     targetBlock.find('.swatchEntry input[title*="continuous"]').prop('disabled', true);
  //   } else {
  //     targetBlock.find('.variantNoticeBox').hide().find('.variantNoticeSelection').html('');
  //     targetBlock.find('.swatchEntry input[title*="continuous"]').prop('disabled', false);
  //   }
  // }
}

function checkRomanShades() {
  // console.info('checkRomanShades()...');

  var clError = false;
  var msg = '';
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $('.builder').find('.sizeEntry.height[data-size]').attr('data-size'),
  );

  // console.log('swatchParentEventTitle:' + swatchParentEventTitle);

  if ($('.swatchEntry input[title="cordless"]').length) {
    $('.swatchEntry input[title="cordless"]').prop('disabled', false);
    if (xWidth < 18 || xWidth > 84) {
      msg +=
        '<span>Cordless is not available with Roman shades measuring less than 18" or more than 84" wide</li>';
      changeOption('cordless', true);

      clError = true;
    }
    if (xHeight < 18 || xHeight > 84) {
      msg +=
        '<span>Cordless is not available with Roman shades measuring less than 18" or more than 84" tall</span>';
      changeOption('cordless', true);
      clError = true;
    }
  }
  if (!clError) {
    msg = '';
    changeOption('cordless', false);
  }
  if ($('.swatchEntry input[title="continuous cord loop"]').length) {
    if (swatchParentEventTitle == 'choose size') {
      // TODO CLEANUP
      $('.swatchEntry [data-sku="cc-24-36"]').show();
      $('.swatchEntry [data-sku="bl-24-36"]').show();
      $('.swatchEntry [data-sku="mw-24-36"]').show();
      $('.swatchEntry [data-sku="cc-36-72"]').hide();
      $('.swatchEntry [data-sku="bl-36-72"]').hide();
      $('.swatchEntry [data-sku="mw-36-72"]').hide();
      $('.swatchEntry [data-sku="cc-72-96"]').hide();
      $('.swatchEntry [data-sku="bl-72-96"]').hide();
      $('.swatchEntry [data-sku="mw-72-96"]').hide();
      $('.swatchEntry [data-sku="cc-96-115"]').hide();
      $('.swatchEntry [data-sku="bl-96-115"]').hide();
      $('.swatchEntry [data-sku="mw-96-115"]').hide();

      if (xWidth > 24 && xWidth <= 36) {
        $('.swatchEntry [data-sku="cc-24-36"]').show();
        $('.swatchEntry [data-sku="bl-24-36"]').show();
        $('.swatchEntry [data-sku="mw-24-36"]').show();
        $('.swatchEntry [data-sku="cc-36-72"]').hide();
        $('.swatchEntry [data-sku="bl-36-72"]').hide();
        $('.swatchEntry [data-sku="mw-36-72"]').hide();
        $('.swatchEntry [data-sku="cc-72-96"]').hide();
        $('.swatchEntry [data-sku="bl-72-96"]').hide();
        $('.swatchEntry [data-sku="mw-72-96"]').hide();
        $('.swatchEntry [data-sku="cc-96-115"]').hide();
        $('.swatchEntry [data-sku="bl-96-115"]').hide();
        $('.swatchEntry [data-sku="mw-96-115"]').hide();
      }

      if (xWidth > 36 && xWidth <= 72) {
        $('.swatchEntry [data-sku="cc-24-36"]').hide();
        $('.swatchEntry [data-sku="bl-24-36"]').hide();
        $('.swatchEntry [data-sku="mw-24-36"]').hide();
        $('.swatchEntry [data-sku="cc-36-72"]').show();
        $('.swatchEntry [data-sku="bl-36-72"]').show();
        $('.swatchEntry [data-sku="mw-36-72"]').show();
        $('.swatchEntry [data-sku="cc-72-96"]').hide();
        $('.swatchEntry [data-sku="bl-72-96"]').hide();
        $('.swatchEntry [data-sku="mw-72-96"]').hide();
        $('.swatchEntry [data-sku="cc-96-115"]').hide();
        $('.swatchEntry [data-sku="bl-96-115"]').hide();
        $('.swatchEntry [data-sku="mw-96-115"]').hide();
      }
      if (xWidth > 72 && xWidth <= 96) {
        $('.swatchEntry [data-sku="cc-24-36"]').hide();
        $('.swatchEntry [data-sku="bl-24-36"]').hide();
        $('.swatchEntry [data-sku="mw-24-36"]').hide();
        $('.swatchEntry [data-sku="cc-36-72"]').hide();
        $('.swatchEntry [data-sku="bl-36-72"]').hide();
        $('.swatchEntry [data-sku="mw-36-72"]').hide();
        $('.swatchEntry [data-sku="cc-72-96"]').show();
        $('.swatchEntry [data-sku="bl-72-96"]').show();
        $('.swatchEntry [data-sku="mw-72-96"]').show();
        $('.swatchEntry [data-sku="cc-96-115"]').hide();
        $('.swatchEntry [data-sku="bl-96-115"]').hide();
        $('.swatchEntry [data-sku="mw-96-115"]').hide();
      }

      if (xWidth > 96) {
        $('.swatchEntry [data-sku="cc-24-36"]').hide();
        $('.swatchEntry [data-sku="bl-24-36"]').hide();
        $('.swatchEntry [data-sku="mw-24-36"]').hide();
        $('.swatchEntry [data-sku="cc-36-72"]').hide();
        $('.swatchEntry [data-sku="bl-36-72"]').hide();
        $('.swatchEntry [data-sku="mw-36-72"]').hide();
        $('.swatchEntry [data-sku="cc-72-96"]').hide();
        $('.swatchEntry [data-sku="bl-72-96"]').hide();
        $('.swatchEntry [data-sku="mw-72-96"]').hide();
        $('.swatchEntry [data-sku="cc-96-115"]').show();
        $('.swatchEntry [data-sku="bl-96-115"]').show();
        $('.swatchEntry [data-sku="mw-96-115"]').show();
      }

      // ok
      setTimeout(function () {
        if (xHeight > 120 || xWidth < 24) {
          msg +=
            '<span>Continuous Cord Loop is not available with Roman shades measuring less than 24" wide or more than 120" tall</span>';
          changeOption('continuous', true);
        } else {
          changeOption('continuous', false);
        }
      }, 100);
    }
  }
  var errBlock = $(
    '.builderBlock[data-question*="choose control style"] .variantNoticeBox',
  );
  if (msg != '') {
    errBlock.show().find('.variantNoticeSelection').html(msg);
  } else {
    errBlock.hide().find('.variantNoticeSelection').html('');
  }

  // inside mount width less 30
  if (
    swatchParentEventTitle == 'choose size' ||
    swatchParentEventTitle == 'choose headrail options' ||
    swatchParentEventTitle == 'choose mount type'
  ) {
    if (
      $('.swatchEntry input[title="outside mount"]:checked').length == 0 ||
      xWidth < 30
    ) {
      changeOption('european / relaxed', true);
    } else {
      changeOption('european / relaxed', false);
    }
  }

  if ($('.builderBlock[data-type="headrail"]').length) {
    if (swatchParentEventTitle == 'choose size') {
      if (xWidth < 48) {
        $('[data-option="headrail options"] .variantEntrySel')
          .first()
          .find('option')
          .eq(1)
          .prop('disabled', true);
        $('[data-option="headrail options"] .variantEntrySel')
          .first()
          .find('option')
          .eq(0)
          .prop('selected', 'selected');
      } else {
        $('[data-option="headrail options"] .variantEntrySel')
          .first()
          .find('option')
          .eq(1)
          .prop('disabled', false);
      }
      // change headrail
      changeHeadrail();
    }
  }
  if (
    swatchParentEventTitle == 'choose size' ||
    swatchParentEventTitle == 'choose headrail options'
  ) {
    if (
      $('.builderBlock[data-type="headrail"]')
        .find('option:selected')
        .attr('title') == 'two on one headrail'
    ) {
      changeOption('cordless', true);
    } else {
      changeOption('cordless', false);
    }
  }

  if (
    $('.swatchEntry input[title="premium blackout liner white"]:checked')
      .length > 0
  ) {
    if (
      $('.swatchEntry input[title="standard flat fold"]:checked').length > 0 ||
      $('.swatchEntry input[title="european / relaxed"]:checked').length > 0
    ) {
      $('.builderBlock[data-question*="liner"] .variantNoticeBox').show();
      $('.builderBlock[data-question*="liner"] .variantNoticeSelection').html(
        '<span>Premium Blackout Liner White is not recommended for Standard Flat Fold or European/Relaxed.</span>',
      );
    } else {
      $('.builderBlock[data-question*="liner"] .variantNoticeBox').hide();
      $('.builderBlock[data-question*="liner"] .variantNoticeSelection').html(
        '',
      );
    }
  } else {
    $('.builderBlock[data-question*="liner"] .variantNoticeBox').hide();
    $('.builderBlock[data-question*="liner"] .variantNoticeSelection').html('');
  }

  // ensure correct dimensions for motorized products
  // width / height specifications provided by Phase II
  handleMotionControl(20, 72, 18, 72, xWidth, xHeight);
}

function checkCellularShades() {
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $('.builder').find('.sizeEntry.height[data-size]').attr('data-size'),
  );

  var msg = '';
  var clError = false;
  var hrError = false;
  var errBlock = $(
    '.builderBlock[data-question*="choose lift"] .variantNoticeBox',
  );
  if ($('.swatchEntry input[title="standard"]').length) {
    if ($('.swatchEntry input[title="standard"]:checked').length > 0) {
      if (xWidth > 96) {
        msg =
          '<span>The size you have choosen is unavaiable as a one piece blind.  Sizes over 96" must be made as a 2 on 1 head rail.</span>';
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(0)
          .prop('disabled', true);
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(1)
          .prop('selected', 'selected');
        clError = true;
      } else {
        $(
          '.builderBlock[data-type="headrail"] .variantEntryOpt[data-option*="options"] option',
        )
          .eq(0)
          .prop('disabled', false);
      }
    }
    if (!clError) {
      msg = '';
      changeOption('standard', false);
    }
  }
  clError = false;
  if ($('.swatchEntry input[title="cordless"]').length) {
    if (xWidth < 18 || xWidth > 84) {
      msg +=
        '<span>All shades measuring less than 18" or more than 84" wide must be Chain Roller (Continuous Cord Loop)</span>';
      changeOption('cordless', true);
      clError = true;
    }
    if (xHeight < 12 || xHeight > 84) {
      msg +=
        '<span>All shades measuring less than 12" or more than 84" tall must be Chain Roller (Continuous Cord Loop)</span>';
      changeOption('cordless', true);
      clError = true;
    }
    if (!clError) {
      msg = '';

      if (
        $(
          '.builderBlock[data-type="headrail"] .variantEntrySel option:selected',
        ).attr('title') == 'two on one headrail'
      ) {
        hrError = true;
        $('.swatchEntry input[title="cordless"]').prop('disabled', false);
        changeOption('cordless', false);
        changeOption('top down bottom up cordless', true);
        changeOption('top down bottom up standard', true);
      } else {
        changeOption('cordless', false);
        changeOption('top down bottom up cordless', false);
        changeOption('top down bottom up standard', false);
      }
    }
  }
  clError = false;
  if ($('.swatchEntry input[title="top down bottom up cordless"]').length) {
    if (xWidth < 18 || xWidth > 72) {
      msg +=
        '<span>Top Down Bottom Up Cordless is not available with shades measuring less than 18" or more than 72" wide</span>';
      changeOption('top down bottom up cordless', true);
      clError = true;
    }
    if (xHeight < 12 || xHeight > 72) {
      msg +=
        '<span>Top Down Bottom Up Cordless is not available with shades measuring less than 12" or more than 72" tall</span>';
      changeOption('top down bottom up cordless', true);
      clError = true;
    }
    if (!clError && !hrError) {
      msg = '';
      changeOption('top down bottom up cordless', false);
    }
  }
  clError = false;
  if ($('.swatchEntry input[title="continuous cord loop"]').length) {
    if ($('[data-oname="continuous cord loop"]:checked').length > 0) {
      if (xWidth > 120) {
        msg =
          '<span>The size you have choosen is unavaiable as a one piece blind.  Sizes over 120" must be made as a 2 on 1 head rail.</span>';
        $('[data-otitle="Headrail Options"] > option')
          .eq(1)
          .prop('disabled', true);
        $('[data-otitle="Headrail Options"] > option')
          .eq(2)
          .prop('selected', 'selected');
        clError = true;
      } else {
        $('[data-otitle="Headrail Options"] > option')
          .eq(1)
          .prop('disabled', false);
      }
    }
    if (xWidth < 18) {
      msg +=
        '<span>Continuous Cord Loop is not available with shades measuring less than 18" wide</span>';
      changeOption('continuous cord loop', true);
      clError = true;
    }
    if (xHeight < 8 || xHeight > 144) {
      msg +=
        '<span>Continuous Cord Loop is not available with shades measuring less than 8" or more than 144" tall</span>';
      changeOption('continuous cord loop', true);

      clError = true;
    }
    if (!clError) {
      msg = '';
      changeOption('continuous cord loop', false);
    }
  }
  clError = false;
  if ($('.swatchEntry input[title="top down bottom up standard"]').length) {
    if (xWidth < 18 || xWidth > 72) {
      msg +=
        '<span>Top Down Bottom Up Standard is not available with shades measuring less than 18" or more than 72" wide</span>';
      changeOption('top down bottom up standard', true);
      clError = true;
    }
    if (xHeight < 18 || xHeight > 72) {
      msg +=
        '<span>Top Down Bottom Up Standard is not available with shades measuring less than 18" or more than 72" tall</span>';
      changeOption('top down bottom up standard', true);
      clError = true;
    }
    if (!clError && !hrError) {
      msg = '';
      changeOption('top down bottom up standard', false);
    }
  }

  handleClutch('cellular shades');

  //$('#control-style-rule-message').html(msg);
  ///console.log('msg:'+msg);
  if (msg != '') {
    errBlock.show().find('.variantNoticeSelection').html(msg);
  } else {
    errBlock.hide().find('.variantNoticeSelection').html('');
  }
}
function checkRollerShades(productName) {
  var msg = '';
  var clError = false;
  $('.builder')
    .find('.sizeEntry.height[data-size]')
    .find('select.parentSize')
    .css({ color: 'black', 'font-weight': 'normal' });
  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $('.builder').find('.sizeEntry.height[data-size]').attr('data-size'),
  );
  $('.builderBlock[data-type="size"] .variantNoticeSelection').empty();

  $('.builderBlock[data-type="size"] .variantNoticeBox').show();
  $('.builderBlock[data-type="size"] .variantNoticeSelection').html(
    'Please note that fabric will be 1 inch narrower than size requested to accommodate for brackets.',
  );

  if (xWidth > 96 && xHeight > 84) {
    // TODO determine best course of action... for now, display warning, set height to valid size and highlight it
    $('.builder')
      .find('.sizeEntry.height[data-size]')
      .find('select.parentSize')
      .val('84')
      .change();
    $('.builder')
      .find('.sizeEntry.height[data-size]')
      .find('select.parentSize')
      .css({ color: 'orange', 'font-weight': 'bold' });
    $('.builderBlock[data-type="size"] .variantNoticeSelection').append(
      '<br/><b>Shades greater than 96" wide must be railroaded (fabric will be turned).  Maximum height is 84".</b>',
    );
  }

  if (xWidth > 96) {
    changeOption('cassette valance', true);
  } else {
    changeOption('cassette valance', false);
  }

  if (/Solar Screen Roller/.test(productName)) {
    if (xWidth <= 60) {
      $('.swatchEntry [data-sku="cv-15-60"]').show();
      $('.swatchEntry [data-sku="cv-61-96"]').hide();
    } else if (xWidth > 60 && xWidth <= 96) {
      $('.swatchEntry [data-sku="cv-15-60"]').hide();
      $('.swatchEntry [data-sku="cv-61-96"]').show();
    }
    // ensure correct dimensions for motorized products
    // width / height specifications provided by Phase II
    handleMotionControl(20, 96, 18, 108, xWidth, xHeight);
  } else if (
    /Blackout/.test(productName) ||
    /Light Filtering/.test(productName)
  ) {
    if (xWidth <= 60) {
      $('.swatchEntry [data-sku="cv-15-60"]').show();
      $('.swatchEntry [data-sku="cv-61-96"]').hide();
      changeOption('cassette valance', false);
    } else if (xWidth > 60 && xWidth <= 96) {
      $('.swatchEntry [data-sku="cv-15-60"]').hide();
      $('.swatchEntry [data-sku="cv-61-96"]').show();
    }
    // ensure correct dimensions for motorized products
    // width / height specifications provided by Phase II
    handleMotionControl(20, 96, 18, 120, xWidth, xHeight);
  } else {
    // ensure correct dimensions for motorized products
    // width / height specifications provided by Phase II
    handleMotionControl(20, 96, 18, 120, xWidth, xHeight);
  }

  if ($('.swatchEntry input[title="cordless"]').length) {
    //cordlessSet1
    if (
      $('.builderWrapper').attr('data-tag').indexOf('rollerCordlessSet1') > -1
    ) {
      if (xWidth < 24 || xWidth > 72) {
        msg +=
          '<span>All roller shades measuring less than 24" or more than 72" wide must be Chain Roller (Continuous Cord Loop)</span>';
        changeOption('cordless', true);
        clError = true;
      }
      if (xHeight < 24 || xHeight > 72) {
        msg +=
          '<span>All roller shades measuring less than 24" or more than 72" tall must be Chain Roller (Continuous Cord Loop)</span>';
        changeOption('cordless', true);
        clError = true;
      }
    }
    //cordlessSet2
    if (
      $('.builderWrapper').attr('data-tag').indexOf('rollerCordlessSet2') > -1
    ) {
      if (xWidth < 15 || xWidth > 73) {
        msg +=
          '<span>All roller shades measuring less than 15" or more than 73" wide must be Chain Roller (Continuous Cord Loop)</span>';
        changeOption('cordless', true);
        clError = true;
      }
      if (xHeight < 24 || xHeight >= 84) {
        msg +=
          '<span>All roller shades measuring either less than 24" or 84" (and greater) tall must be Chain Roller (Continuous Cord Loop)</span>';
        changeOption('cordless', true);
        clError = true;
      }
    }
    // jQuery('[data-otitle="Lift Side"][data-oname="left"]').change(function(e) {
    //     e.preventDefault();
    // });
    if (swatchParentEventTitle.indexOf('lift side') == -1) {
      if ($('.swatchEntry input[title="cordless"]:checked').length > 0) {
        // disable option and enable none
        $('[data-question*="lift side"] .swatchEntry input').prop(
          'disabled',
          true,
        );
        $('[data-question*="lift side"] .swatchEntry input[title="none"]').prop(
          'disabled',
          false,
        );
        $('[data-question*="lift side"] .swatchEntry input[title="none"]').prop(
          'checked',
          true,
        );
        $('[data-question*="lift side"] [data-property]').val('None');
      } else {
        // enable all and disable none
        if (swatchParentEventTitle.indexOf('lift side') == -1) {
          // console.log('not lift change');
          $('[data-question*="lift side"] [data-property]').val('');
          $('[data-question*="lift side"] .swatchEntry input').prop(
            'checked',
            false,
          );
        }
        $('[data-question*="lift side"] .swatchEntry input').prop(
          'disabled',
          false,
        );
        $('[data-question*="lift side"] .swatchEntry input[title="none"]').prop(
          'disabled',
          true,
        );
        $('[data-question*="lift side"] .swatchEntry input[title="none"]').prop(
          'checked',
          false,
        );
      }
    }
    //console.log('swatchParentEventTitle:'+swatchParentEventTitle);
  }
  if (!clError) {
    msg = '';
    changeOption('cordless', false);
  }
  if (msg != '') {
    $('.builderBlock[data-question*="control style"] .variantNoticeBox').show();
    $(
      '.builderBlock[data-question*="control style"] .variantNoticeSelection',
    ).html(msg);
  } else {
    $('.builderBlock[data-question*="control style"] .variantNoticeBox').hide();
  }
}

// TODO implement
// function selectOptionByDimension(optionCode, width, height){
//   const codes = {
//     'cv': 'Cassette Valance',
//     'ps': 'Privacy Slats',
//     'ct': 'Cloth Tape',
//     'cc': 'Continuous Cord Loop'
//   };
// }

function checkCassetteValance() {
  var msg = '';
  var cvError = false;
  // if change size

  // if ($('.swatchEntry input[title="cassette valance"]:checked').length > 0) {
  //   msg = '<span>Please note that fabric will be 1&#189;  inch narrower than size requested to accommodate for brackets.</span>';
  // } else {
  //   msg = '';
  // }

  // if (msg != '') {
  //   $('.builderBlock[data-question*="cassette valance"] .variantNoticeBox').show();
  //   $('.builderBlock[data-question*="cassette valance"] .variantNoticeSelection').html(msg);
  // } else {
  //   $('.builderBlock[data-question*="cassette valance"] .variantNoticeBox').hide();
  // }
  //console.log('swatchParentEventTitle:'+swatchParentEventTitle);

  if (swatchParentEventTitle.indexOf('roll direction') > -1) {
    //$('.builderBlock[data-question*="cassette valance"] .swatchEntry input').prop('disabled', false).prop('checked', false);
    //$('[data-question*="cassette valance"] [data-property]').val('');
    changeOption('cassette valance', false);
  }

  if ($('.swatchEntry input[title*="reverse"]:checked').length > 0) {
    //$('.swatchEntry input[title*="cassette valance"]').prop('disabled', true);
    changeOption('cassette valance', true);

    $('.builderBlock[data-question*="cassette valance"] .variantNoticeBox')
      .show()
      .find('.variantNoticeSelection')
      .html('Cassette valances are not available in reverse roll');
  } else {
    $('.builderBlock[data-question*="cassette valance"] .variantNoticeBox')
      .hide()
      .find('.variantNoticeSelection')
      .html('');
  }
}

function validateCassetteValance(cCheckedTitle) {
  // var targetBlock = $('.builderBlock[data-question*="cassette valance"]');
  // targetBlock.find('.prodvariant').val('');
  // targetBlock.find('[data-property]').val('');
  // targetBlock.find('.swatchEntry input').prop('disabled', false).prop('checked', false);
  // if (cCheckedTitle.indexOf('reverse') > -1) {
  //   targetBlock.find('.swatchEntry input[title*="cassette valance"]').prop('disabled', true);
  //   targetBlock.find('.variantNoticeBox').show().find('.variantNoticeSelection').html('Cassette valances are not avaiable in reverse roll');
  // } else {
  //   targetBlock.find('.variantNoticeBox').hide().find('.variantNoticeSelection').html('');
  // }
}

function checkVerticalBlinds() {
  // already set in  metafields
}
function checkZebraShades() {
  var msg = '';
  var cordlessSet = [6782, 7596];
  var clError = false;

  // TODO: cordless doesn't seem to be an option for Zebra shades anymore...
  // verify that this should be the case
  if ($('.swatchEntry input[title="cordless"]').length) {
    //if (cordlessSet.indexOf(globalOptions.productID) != -1) {
    if (xWidth < 18 || xWidth > 72) {
      msg +=
        '<span>Cordless is not available with shades measuring less than 18" or more than 72" wide</span>';
      $('.swatchEntry input[title="cordless"]').prop('disabled', true);
      clError = true;
    }
    if (xHeight < 18 || xHeight > 72) {
      msg +=
        '<span>Cordless is not available with shades measuring less than 18" or more than 72" tall must be Chain Roller (Continuous Cord Loop)</span>';
      $('.swatchEntry input[title="cordless"]').prop('disabled', true);
      clError = true;
    }
    if (!clError) {
      msg = '';
      $('.swatchEntry input[title="cordless"]').prop('disabled', false);
    }
    if (msg != '') {
      $('.swatchEntry input[title="cordless"]')
        .closest('.builderBlock')
        .find('variantNoticeBox')
        .show();
      $('.swatchEntry input[title="cordless"]')
        .closest('.builderBlock')
        .find('variantNoticeSelection')
        .html('');
    } else {
      $('.swatchEntry input[title="cordless"]')
        .closest('.builderBlock')
        .find('variantNoticeBox')
        .hide();
    }
    //}
  }

  let xWidth = parseFloat(
    $('.builder').find('.sizeEntry.width[data-size]').attr('data-size'),
  );
  let xHeight = parseFloat(
    $('.builder').find('.sizeEntry.height[data-size]').attr('data-size'),
  );

  // ensure correct dimensions for motorized products
  // TODO write similar method for handleCordless
  // width / height specifications provided by Phase II
  handleMotionControl(20, 94, 18, 94, xWidth, xHeight);
}

// Motorwand lift mechanism has the capacity for the following dimensions:
// Width - 20" - 115"W
// Length - 24 - 120"L
function isValidMotorwand(chosenWidth, chosenHeight) {
  return chosenWidth >= 20 &&
    chosenWidth <= 115 &&
    chosenHeight >= 24 &&
    chosenHeight <= 120
    ? true
    : false;
}

// motorization can have varying min/max width/height
function isValidMotorized(
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  chosenWidth,
  chosenHeight,
) {
  return chosenWidth >= minWidth &&
    chosenWidth <= maxWidth &&
    chosenHeight >= minHeight &&
    chosenHeight <= maxHeight
    ? true
    : false;
}

// enable / disable Clutch Side based on Lift Style == Clutch
// enable / disable motorized options as well (Roman Shades only)
function handleClutch(productType) {
  if (productType == 'cellular shades') {
    var selectedOption = $('.builderBlock[data-question*="choose lift style"]')
      .find('option:selected')
      .attr('data-sku');

    if (
      selectedOption == 'clutch-lift' ||
      selectedOption == 'clutch-lift-tdbu'
    ) {
      $('.swatchEntry input[title="clutch left"]').prop('disabled', false);
      $('.swatchEntry input[title="clutch right"]').prop('disabled', false);
      $('.builderBlock[data-question*="clutch side"] .prodvariant')
        .attr('data-add', true)
        .prop('required', true);
      $('.builderBlock[data-question*="clutch side"] [data-property]').prop(
        'required',
        true,
      );
    } else {
      // disable Clutch Side, clear in case chosen
      $('.swatchEntry input[title="clutch left"]')
        .prop('checked', false)
        .prop('disabled', true);
      $('.swatchEntry input[title="clutch right"]')
        .prop('checked', false)
        .prop('disabled', true);
      $('.builderBlock[data-question*="clutch side"] .prodvariant')
        .attr('data-add', false)
        .prop('required', false);
      $('.builderBlock[data-question*="clutch side"] [data-property]').prop(
        'required',
        false,
      );
      // NOTE: change event must be triggered in order to clear the shown value within the new builder
      $('.builderBlock[data-question*="clutch side"] [data-property]')
        .val('')
        .trigger('change');
    }
  } else if (productType == 'roman shades') {
    // TODO: implement once backend is complete
  }
}

// motorized products may be controlled by remote, motorwand, or smart hub
// check whether motorwand or motorization + options is available based on width
function handleMotionControl(
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  chosenWidth,
  chosenHeight,
) {
  // reset lift cord in case user is switching from cordless to something else
  enableLiftCord();

  if (
    $('.swatchEntry input[title="continuous cord loop"]:checked').length > 0
  ) {
    enableCordedLoop();
    console.log('Disable motorized options for CCL');
    // disable lift options for motorwand without disabling control style
    disableMotorwandLift();

    // disable motion-related accessories
    disableMotorwandCharger();
    disableRemoteControl();
    disableSmartHub();
  } else if (
    $('.swatchEntry input[title="cordless"]').prop('checked')
    //    $('.swatchEntry input[title="motorized"]').prop('checked') ||
    //    $('.swatchEntry input[title="motorwand"]:checked').length > 0
  ) {
    // primarily for Solar + Roller Shades
    disableLiftSide();
    disableLiftCord();
  } else if (
    $('.swatchEntry input[title="right-continuous loop system"]').prop(
      'checked',
    ) ||
    $('.swatchEntry input[title="left-continuous loop system"]').prop('checked')
  ) {
    // primarily for Zebra shades
    disableMotorwandCharger();
    disableRemoteControl();
    disableSmartHub();
  } else {
    enableLiftCord();
    console.log('Checking dimensions for motorwand spec...');
    if (isValidMotorwand(chosenWidth, chosenHeight)) {
      console.log('Valid for Motorwand');
      enableMotorwand();

      if (
        $('.swatchEntry input[title="motorwand"]:checked').length > 0 ||
        $('.swatchEntry input[title="motorwand (left)"]').prop('checked') ||
        $('.swatchEntry input[title="motorwand (right)"]').prop('checked')
      ) {
        // product is within spec, motorwand chosen
        console.log('motorwand product is within spec');
        enableMotorwandCharger();

        // Roman and Zebra shades both use Lift Cord differently...
        // TODO on Roman shades this causes issues if Motorwand (Left/Right) is chosen
        // and then Control Style is changed to CCL; needs a fix
        if (
          !$('.swatchEntry input[title="motorwand (left)"]').prop('checked') &&
          !$('.swatchEntry input[title="motorwand (right)"]').prop('checked')
        ) {
          disableCordedLoop();
        }

        // for Solar + Roller shades as there's Motorwand (Left / Right) options
        enableLiftSide();

        // remove / disable motorized accessories
        disableRemoteControl();
        disableSmartHub();
      } else {
        // product is within spec but no motorwand chosen
        enableMotorwand();

        // remove + disable any related accessories
        disableMotorwandCharger();

        // enable continuous cord and lift side where applicable
        enableCordedLoop();
        enableLiftSide();
      }
    } else {
      console.log('Not valid for Motorwand');
      // disable motorwand, remove + disable accessories
      disableMotorwand();

      enableCordedLoop();

      enableLiftSide();
    }

    if (
      isValidMotorized(
        minWidth,
        maxWidth,
        minHeight,
        maxHeight,
        chosenWidth,
        chosenHeight,
      )
    ) {
      console.log('Valid for Motorization');
      enableMotorization();

      if ($('.swatchEntry input[title="motorized"]').prop('checked')) {
        // motorized product is within spec and selected
        console.log('motorized product is within spec');
        // if classic motorization is chosen then require remote control, enable smart hub, disable motorwand charger
        disableMotorwandLift();
        disableCordedLoop();
        disableLiftSide();
	disableLiftCord();
      } else {
        // product is within spec but no motorization
        // enable continuous cord and lift side where applicable
        enableCordedLoop();

        // remove + disable any related accessories
        disableRemoteControl();

        disableSmartHub();
      }
    } else {
      // out of motorization spec, disable and remove any accessories
      console.log('Not valid for Motorization');

      disableMotorization();

      enableCordedLoop();

      enableLiftSide();

      enableLiftCord();
    }
  }

  // hacky? fix bug related to accessories not being properly removed from the summary
  // TODO: refactor buildSummary
  buildSummary();
}

function disableMotorization() {
  $('.swatchEntry input[title="motorized"]')
    .prop('checked', false)
    .prop('disabled', true);

  disableRemoteControl();
  disableSmartHub();
}

function enableMotorization() {
  // abstract from handleMotionControl
  $('.swatchEntry input[title="motorized"]').prop('disabled', false);

  enableRemoteControl();
  enableSmartHub();
}

function enableSmartHub() {
  $('.swatchEntry input[title="smart hub"]').prop('disabled', false);
  $('.builderBlock[data-question*="smart hub"] .prodvariant').attr(
    'data-add',
    true,
  );
}

function disableSmartHub() {
  $('.swatchEntry input[title="smart hub"]')
    .prop('checked', false)
    .prop('disabled', true);
  $('.builderBlock[data-question*="smart hub"] .prodvariant').attr(
    'data-add',
    false,
  );
  $('.builderBlock[data-question*="smart hub"] [data-property]').val('');
}

function enableRemoteControl() {
  $('.builderBlock[data-question*="remote control"] .prodvariant')
    .attr('data-add', true)
    .prop('required', true);
  $('.builderBlock[data-question*="remote control"] [data-property]').prop(
    'required',
    true,
  );

  $('.builderBlock[data-question*="remote control"] .prodvariant').attr(
    'data-add',
    true,
  );
}

function disableRemoteControl() {
  $('.builderBlock[data-question*="remote control"] .prodvariant')
    .attr('data-add', false)
    .prop('required', false);
  $('.builderBlock[data-question*="remote control"] [data-property]')
    .val('')
    .prop('required', false);

  $('.builderBlock[data-question*="remote control"] .swatchEntry input').prop(
    'checked',
    false,
  );

  $('.builderBlock[data-question*="remote control"] .errorMsg').remove();
}

function disableLiftCord() {
  $('.builderBlock[data-question*="lift cord"] .prodvariant')
    .attr('data-add', false)
    .prop('required', false);
  $('.builderBlock[data-question*="lift cord"] [data-property]')
    .val('')
    .prop('required', false);

  $('.builderBlock[data-question*="lift cord"] .swatchEntry input').prop(
    'checked',
    false,
  );

  $('.builderBlock[data-question*="lift cord"] .errorMsg').remove();
}

function enableLiftCord() {
  $('.builderBlock[data-question*="lift cord"] .prodvariant')
    .attr('data-add', true)
    .prop('required', true);
  $('.builderBlock[data-question*="lift cord"] [data-property]').prop(
    'required',
    true,
  );

  $('.builderBlock[data-question*="lift cord"] .prodvariant').attr(
    'data-add',
    true,
  );
}

function disableMotorwand() {
  // abstracted from handleMotionControl
  $('.swatchEntry input[title="motorwand"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="motorwand - mw-24-36"]')
    .prop('checked', false)
    .prop('disabled', true);
  $('.swatchEntry input[title="motorwand - mw-36-72"]')
    .prop('checked', false)
    .prop('disabled', true);
  $('.swatchEntry input[title="motorwand - mw-72-96"]')
    .prop('checked', false)
    .prop('disabled', true);
  $('.swatchEntry input[title="motorwand - mw-96-115"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="motorwand (right)"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="motorwand (left)"]')
    .prop('checked', false)
    .prop('disabled', true);

  // TODO: will this have side effects?
  $('[data-question*="lift cord"] [data-property]').val('').trigger('change');

  disableMotorwandCharger();
}

function disableMotorwandLift() {
  $('.swatchEntry input[title="motorwand (right)"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="motorwand (left)"]')
    .prop('checked', false)
    .prop('disabled', true);
}

function enableMotorwand() {
  $('.swatchEntry input[title="motorwand"]').prop('disabled', false);
  // dynamic pricing for roman shades
  $('.swatchEntry input[title="motorwand - mw-24-36"]').prop('disabled', false);
  $('.swatchEntry input[title="motorwand - mw-36-72"]').prop('disabled', false);
  $('.swatchEntry input[title="motorwand - mw-72-96"]').prop('disabled', false);
  $('.swatchEntry input[title="motorwand - mw-96-115"]').prop(
    'disabled',
    false,
  );

  // ensure lift-cord options are enabled
  $('.swatchEntry input[title="motorwand (left)"]').prop('disabled', false);
  $('.swatchEntry input[title="motorwand (right)"]').prop('disabled', false);

  enableMotorwandCharger();
}

function disableMotorwandCharger() {
  $('.swatchEntry input[title="motorwand charger"]')
    .prop('checked', false)
    .prop('disabled', true);
  $('.builderBlock[data-question*="motorwand charger"] .prodvariant').attr(
    'data-add',
    false,
  );
  $('[data-question*="motorwand charger"] [data-property]')
    .val('')
    .trigger('change');
}

function enableMotorwandCharger() {
  $('.swatchEntry input[title="motorwand charger"]').prop('disabled', false);

  // TODO: is this necessary?
  $('.builderBlock[data-question*="motorwand charger"] .prodvariant').attr(
    'data-add',
    false,
  );
}

function disableCordedLoop() {
  $('.swatchEntry input[title="right-continuous loop system"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="left-continuous loop system"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="left back continuous cord"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('.swatchEntry input[title="right back continuous cord"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('[data-question*="lift cord"] [data-property]').val('').trigger('change');
}

function enableCordedLoop() {
  $('.swatchEntry input[title="right-continuous loop system"]').prop(
    'disabled',
    false,
  );

  $('.swatchEntry input[title="left-continuous loop system"]').prop(
    'disabled',
    false,
  );

  $('.swatchEntry input[title="left back continuous cord"]').prop(
    'disabled',
    false,
  );

  $('.swatchEntry input[title="right back continuous cord"]').prop(
    'disabled',
    false,
  );
}

function enableLiftSide() {
  // TODO pass in product type?
  $('[data-question*="lift side"] .swatchEntry input').prop('disabled', false);

  $('[data-question*="lift side"] .swatchEntry input[title="none"]').prop(
    'disabled',
    false,
  );

  $('.builderBlock[data-question*="lift side"] .prodvariant')
    .attr('data-add', true)
    .prop('required', true);

  $('.builderBlock[data-question*="lift side"] [data-property]').prop(
    'required',
    true,
  );

  $('[data-question*="lift side"] .swatchEntry input').prop('disabled', false);
}

function disableLiftSide() {
  // TODO pass in product type?
  // disable relevant lift cord types + lift side
  $('[data-question*="lift side"] .swatchEntry input')
    .prop('checked', false)
    .prop('disabled', true);

  $('[data-question*="lift side"] .swatchEntry input[title="none"]')
    .prop('checked', false)
    .prop('disabled', true);

  $('[data-question*="lift side"] .swatchEntry input').prop('disabled', true);

  $('.builderBlock[data-question*="lift side"] .prodvariant')
    .attr('data-add', false)
    .prop('required', false);

  $('.builderBlock[data-question*="lift side"] [data-property]').prop(
    'required',
    false,
  );

  $('[data-question*="lift side"] [data-property]').val('').trigger('change');
}

function checkWovenShades() {}

function decimalToFraction(num) {
  if (num == 0) {
    return '';
  } else if (num == 0.125) {
    return '1/8';
  } else if (num == 0.25) {
    return '1/4';
  } else if (num == 0.375) {
    return '3/8';
  } else if (num == 0.5) {
    return '1/2';
  } else if (num == 0.625) {
    return '5/8';
  } else if (num == 0.75) {
    return '3/4';
  } else if (num == 0.875) {
    return '7/8';
  }
}
function setHeadRailProp() {
  var $headRail = $('.builderBlock[data-type="headrail"]');
  var headRailProp = '';
  var headRailPreProp = '';
  var headRailBlind1_Prop = '';
  var headRailBlind1_Width = '';
  var headRailBlind1_SubProp = '';
  var headRailBlind2_Prop = '';
  var headRailBlind2_Width = '';
  var headRailBlind2_SubProp = '';

  $headRail.find('.variantEntryOpt').each(function () {
    var variantKey = $.trim($(this).find('label').text());
    var variantVal = $.trim($(this).find('.variantEntrySel').val());
    headRailPreProp = headRailPreProp + variantKey + ': ' + variantVal + ', ';
  });

  if ($('#width-crtl-inch-1').is(':enabled')) {
    if ($('#width-crtl-frac-1').val() == '.0') {
      headRailBlind1_Width =
        'Blind 1 Width: ' +
        $.trim($('#width-crtl-inch-1 option:selected').text()) +
        '"';
    } else {
      headRailBlind1_Width =
        'Blind 1 Width: ' +
        $.trim($('#width-crtl-inch-1 option:selected').text()) +
        ' ' +
        $.trim($('#width-crtl-frac-1 option:selected').text());
    }

    if (xCat.includes('roman shades')) {
      // so hacky
      // see https://app.asana.com/0/1199569730056415/1200311258049865
      // console.info('Removing / disabling tilt for Roman Shades (note: 2:1 headrail not available)');

      // console.info('Tilt removed / disabled for Roman Shades (note: 2:1 headrail not available)');
      document.getElementById('tilt-loc-1').disabled = true;
    }

    if (
      document.getElementById('tilt-loc-1') &&
      document.getElementById('tilt-loc-1').disabled
    ) {
      headRailBlind1_SubProp =
        'Blind 1 ' +
        $('#lift-loc-1').attr('data-oname') +
        ': ' +
        $.trim($('#lift-loc-1 option:selected').text());
    } else {
      headRailBlind1_SubProp =
        'Blind 1 ' +
        $('#tilt-loc-1').attr('data-oname') +
        ': ' +
        $.trim($('#tilt-loc-1 option:selected').text()) +
        ', Blind 1 ' +
        $('#lift-loc-1').attr('data-oname') +
        ': ' +
        $.trim($('#lift-loc-1 option:selected').text());
    }

    headRailBlind1_Prop =
      '' + headRailBlind1_Width + ', ' + headRailBlind1_SubProp + '';

    if (xCat.includes('roman shades')) {
      // so hacky
      // see https://app.asana.com/0/1199569730056415/1200311258049865
      // console.info('Removing / disabling tilt for Roman Shades (note: 2:1 headrail not available)');

      // console.info('Tilt removed / disabled for Roman Shades (note: 2:1 headrail not available)');
      headRailBlind1_Prop.replace('Blind 1 Tilt Location: Left, ', '');
      document.querySelectorAll('.tilt-loc').forEach(function (tilt) {
        tilt.style.display = 'none';
      });
    }
  }

  // blind 2
  if ($('#width-crtl-inch-2').is(':enabled')) {
    if ($('#width-crtl-frac-2').val() == '.0') {
      headRailBlind2_Width =
        ', Blind 2 Width: ' +
        $.trim($('#width-crtl-inch-2 option:selected').text()) +
        '"';
    } else {
      headRailBlind2_Width =
        ', Blind 2 Width: ' +
        $.trim($('#width-crtl-inch-2 option:selected').text()) +
        ' ' +
        $.trim($('#width-crtl-frac-2 option:selected').text());
    }

    if (
      document.getElementById('tilt-loc-2') &&
      document.getElementById('tilt-loc-2').disabled
    ) {
      headRailBlind2_SubProp =
        'Blind 2 ' +
        $('#lift-loc-2').attr('data-oname') +
        ': ' +
        $.trim($('#lift-loc-2 option:selected').text());
    } else {
      headRailBlind2_SubProp =
        'Blind 2 ' +
        $('#tilt-loc-2').attr('data-oname') +
        ': ' +
        $.trim($('#tilt-loc-2 option:selected').text()) +
        ', Blind 2 ' +
        $('#lift-loc-2').attr('data-oname') +
        ': ' +
        $.trim($('#lift-loc-2 option:selected').text());
    }

    headRailBlind2_Prop =
      '' + headRailBlind2_Width + ', ' + headRailBlind2_SubProp + '';
  }

  // set property
  headRailProp = headRailPreProp + headRailBlind1_Prop + headRailBlind2_Prop;
  $headRail.find('[data-property]').val(headRailProp).trigger('change');
}

function checkRequired(isValidated) {
  $('.builderBlock  [data-property][required]').each(function () {
    var propVal = $(this).val();
    if (propVal == '') {
      $(this).closest('.builderBlock').addClass('blockError');
      $(this).closest('.builderBlock').find('.errorMsg').remove();
      $(this)
        .closest('.builderBlock')
        .find('.lineItemProp')
        .after('<div class="errorMsg">This is a required field.</div>');
    } else {
      $(this).closest('.builderBlock').removeClass('blockError');
      $(this).closest('.builderBlock').find('.errorMsg').remove();
    }
  });

  if (isValidated) {
  } else {
    if ($('.builderBlock.blockError').length > 0) {
      $('.builder-option').hide();
      $('.builderBlock.blockError')
        .first()
        .closest('.builder-step')
        .find('.builder-option')
        .fadeIn(200);

      var errPos =
        $('.builderBlock.blockError').first().closest('.builder-step').offset()
          .top - 100;

      // console.log(errPos);
      $('html, body').animate(
        {
          scrollTop: errPos,
        },
        300,
      );
    }
  }
}

function addItem(id, qty, properties) {
  console.info(`Adding item ${id}...`);
  var params = {
    quantity: qty,
    id: id,
  };
  if (properties != false) {
    params.properties = properties;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function () {},
    error: function () {
      // console.log(params);
      alert('Error. Please try again');
    },
  });
}

function buildBundle() {
  console.log('Starting bundle build...');

  var bundleIds = '';
  var parentID = $('.prodvariant[data-prop="size"]').val();
  var prodTitle = $('.builderWrapper h2').text();
  var addQTY = $('#builderQty').val();
  var timeStamp = Date.now();
  var bundleHandle = $('.builderWrapper h2').attr('data-handle');
  // set cookie on bundle URL
  //Cookies.set('bundleHandle', , { path: '/', expires: 365 });
  var addProp = {
    //'_BundleType': 'Child',
    Bundle: prodTitle,
    _BundleHandle: bundleHandle,
    _Timestamp: timeStamp,
  };

  // loop bundle in reverse
  // console.log('bundleIds:' + bundleIds);
  $('.prodvariant[data-add]')
    .reverse()
    .each(function (index) {
      var addID = $(this).val();
      var addPrice = parseFloat(
        $(this).find('option:selected').attr('data-price'),
      );
      var addLabel = $(this)
        .closest('.builderBlock ')
        .find('[data-property]')
        .attr('data-property');
      var addValid = true;
      // check if entry is valid
      if (addID == '') {
        addValid = false;
      }
      if (addID === null) {
        addValid = false;
      }
      // valid item and price higher than zero
      if (addValid == true && addPrice > 0) {
        if (Array.isArray(addID) == false) {
          if (addLabel != 'Size') {
            bundleIds = bundleIds + ', ' + addID;
            //console.log(addLabel+':'+addID);
            //console.log(bundleIds);
            push_to_queue(addID, addQTY, addProp, '');
          }
        } else {
          $.each(addID, function (index, value) {
            bundleIds = bundleIds + ', ' + value;
            //console.log(addLabel+'::'+value);
            //console.log(bundleIds);
            push_to_queue(value, addQTY, addProp, '');
          });
        }
      }
    });
  // bundle id will be used for error checking in cart

  bundleIds = parentID + bundleIds;

  // console.log('bundleIds:' + bundleIds);
  // get parent product  variant id
  //alert('build properties');
  var addPropParent = {
    //'_BundleType': 'Parent',
    Bundle: prodTitle,
    _BundleHandle: bundleHandle,
    _BundleImg: $('.builderWrapper h2').attr('data-image'),
    _Timestamp: timeStamp,
    _BundleIds: bundleIds,
    _BundleSubtotal: parseFloat($('.builderSubTotal').html()).toFixed(2),
    _BundleCompareSubtotal: parseFloat($('.compareSubTotal').html()).toFixed(2),
    _colorCode: $(
      '.builderBlock[data-type="color"] .variantEntry option:selected',
    ).attr('data-sku'),
  };
  // pass property to parent
  $('[data-property]').each(function (index) {
    var propVal = $(this).val();
    var propLabel = $(this).attr('data-property');
    //console.log('propLabel:'+propLabel,);
    if (propLabel.toLowerCase() == 'size') {
      var widthLabel = propVal.split(', ')[0].split(': ')[0];
      var widthVal = propVal.split(', ')[0].split(': ')[1];
      var heightLabel = propVal.split(', ')[1].split(': ')[0];
      var heightVal = propVal.split(', ')[1].split(': ')[1];
      addPropParent[widthLabel] = widthVal;
      addPropParent[heightLabel] = heightVal;
    } else if (propLabel.toLowerCase() == 'headrail options') {
      var headrailVal = propVal
        .split(', ')[0]
        .replace('Headrail Options: ', '');
      addPropParent['Headrail Options'] = headrailVal;

      var headrailDetail = propVal
        .replace('Headrail Options: ', '')
        .replace('Standard Headrail, ', '')
        .replace('Two on One Headrail, ', '');
      addPropParent['Headrail Details'] = headrailDetail;
    } else {
      if (propVal != '') {
        addPropParent[propLabel] = propVal;
      }
    }
  });
  //console.log(parentID);
  // console.log(addPropParent);
  // console.log(addProp);

  // add parent product
  push_to_queue(parentID, addQTY, addPropParent, Shopify.moveAlong);
}

Shopify.queue = [];
Shopify.moveAlong = function () {
  // console.info(`Moving along...!?`);
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
    Shopify.addItem(
      request.variantId,
      request.quantity,
      request.properties,
      Shopify.moveAlong,
    );
  } else {
    document.location.href = '/cart';
    //alert('added');
  }
};
Shopify.addItem = function (id, qty, properties, callback) {
  // console.info(`Shopify.addItem ${id}:`);
  var params = {
    quantity: qty,
    id: id,
  };
  if (properties != false) {
    params.properties = properties;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function () {
      if (typeof callback === 'function') {
        callback();
      }
    },
    error: function () {
      alert('Error: Try Again');
      // console.log(params);
    },
  });
};

function push_to_queue(variantID, quantity, properties, callback) {
  // console.info(`Pushing to queue...!?`);
  Shopify.queue.push({
    variantId: variantID,
    quantity: quantity,
    properties: properties,
  });
  if (typeof callback === 'function') {
    callback();
  }
}

function removeCartConfirm(cartTS, editUrl, errorTitle, bundleErrorMsg) {
  // console.info(`removeCartConfirm:`);
  $.confirm({
    title: errorTitle,
    content: bundleErrorMsg,
    type: 'red',
    typeAnimated: true,
    columnClass: 'smallsmall--one-half medium-up--one-quarter',
    buttons: {
      tryAgain: {
        text: 'Ok',
        btnClass: 'btn-red',
        action: function () {
          // remove cart and go to product builder
          $.ajaxSetup({
            async: false,
          });
          $('.cart__row[data-time="' + cartTS + '"]').each(function () {
            var xID = $(this).attr('data-cart-item-key');
            jQuery.post('/cart/change.js', {
              id: xID,
              quantity: 0,
            });
            // console.log('remove:' + xID);
          });
          document.location.href = editUrl;
          $.ajaxSetup({
            async: true,
          });
        },
      },
    },
  });
}

function buildSummary() {
  console.info(`Generating build summary:`);
  $('.builderSummary').html('');
  $('.lineItemProp [data-property]').each(function () {
    var pThis = $(this);
    var prop = $(this).attr('data-property');
    var propVal = $(this).val();
    var propCode = '';
    var headrailOpt = '';
    //console.log('prop:' + prop);
    if (propVal != '') {
      if (prop.indexOf('Size') > -1) {
        var widthVal = propVal.split(', ')[0].replace('Width: ', '');
        var heightVal = propVal.split(', ')[1].replace('Height: ', '');

        propCode =
          '<dl><dt>Size</dt><dd><div>Width: ' +
          widthVal +
          '</div><div>Height: ' +
          heightVal +
          '</div></dd></dl>';
      } else if (prop.indexOf('Headrail Option') > -1) {
        if (pThis) var propCodeVal = '';
        var propVal = propVal.replace(/_/g, ' ');
        var headPrimary = $.trim(propVal.split(', Blind 1 Width: ')[0]);
        var headArr = headPrimary.split(', ');
        var headProp = '';

        var headBlind1PropVal = $.trim(propVal.split('Blind 1 Width: ')[1]);
        var headBlind1 = 'Blind 1 Width: ' + headBlind1PropVal;
        var headBlind1 = headBlind1.split(', Blind 2 Width:')[0];
        var headBlind1Arr = headBlind1.split(', ');
        var headBlind1Prop = '<strong>Blind 1</strong>';
        //console.log(headBlind1Arr);
        $.each(headBlind1Arr, function (key, value) {
          headBlind1Prop = headBlind1Prop + '<span>' + value + '</span>';
        });
        propCodeVal = propCodeVal + '<p>' + headBlind1Prop + '</p>';

        var headBlind2PropVal = $.trim(propVal.split('Blind 2 Width: ')[1]);
        if (headBlind2PropVal != '') {
          var headBlind2 = $.trim(
            'Blind 2 Width: ' + propVal.split('Blind 2 Width: ')[1],
          );
          var headBlind2Arr = headBlind2.split(', ');
          var headBlind2Prop = '<strong>Blind 2</strong>';
          $.each(headBlind2Arr, function (key, value) {
            headBlind2Prop = headBlind2Prop + '<span>' + value + '</span>';
          });
          propCodeVal = propCodeVal + '<p>' + headBlind2Prop + '</p>';
        }
        //console.log(propCodeVal);

        propCode =
          propCode +
          '<dl class="wide"><dt>Headrail Details</dt><dd><div>' +
          propCodeVal +
          '</div></dd></dl>';
        //console.log(propCode);

        $.each(headArr, function (key, value) {
          //console.log('headArrKey:'+value);
          var xV = value.split(': ');
          headProp =
            headProp +
            '<dl><dt>' +
            xV[0] +
            '</dt><dd><div>' +
            xV[1] +
            '</div></dd></dl>';
          // if (value.indexOf('Headrail Options') > -1) {
          //   headrailOpt = value.split(': ')[1]
          // } else {
          //   headProp = headProp + '<span>' + value + '</span>';
          // }
        });
        //console.log(headProp);
        propCode = headProp + propCode;
      } else if (prop.indexOf('Hardware') > -1) {
        var hardwareArr = propVal.split(', ');
        var hardwareCodeVal = '';
        $.each(hardwareArr, function (key, value) {
          hardwareCodeVal = hardwareCodeVal + '<div>' + value + '</div>';
        });
        propCode =
          '<dl><dt>' +
          prop +
          '</dt><dd><div>' +
          hardwareCodeVal +
          '</div></dd></dl>';
      } else if (prop.indexOf('Notes') > -1) {
        var noteArr = propVal.split(', ');
        var noteCodeVal = '';
        $.each(noteArr, function (key, value) {
          noteCodeVal = noteCodeVal + '<div>' + value + '</div>';
        });
        propCode =
          '<dl><dt>' +
          prop +
          '</dt><dd><div>' +
          noteCodeVal +
          '</div></dd></dl>';
      } else {
        propCode =
          '<dl><dt>' + prop + '</dt><dd><div>' + propVal + '</div></dd></dl>';
      }
      $('.builderSummary').append(propCode);
    }
  });
}
function updateHeadrailSKU() {
  $('.blind-size select').trigger('change');

  // set headrail dynamic sku prop
  var t_1_val = $('#tilt-loc-1').val();
  var l_1_val = $('#lift-loc-1').val();
  var t_2_val = $('#tilt-loc-2').val();
  var l_2_val = $('#lift-loc-2').val();
  var h_o_val = $('[data-option="headrail options"] .variantEntrySel').val();

  $('.headrailOpts').val(h_o_val);
  if (t_1_val != null && l_1_val != null) {
    $('.blindSKU_1').val(t_1_val + ' / ' + l_1_val);
  } else {
    $('.blindSKU_1').val('');
  }
  if (t_2_val != null && l_2_val != null) {
    $('.blindSKU_2').val(t_2_val + ' / ' + l_2_val);
  } else {
    $('.blindSKU_2').val('');
  }
}

function changeOption(title, disable) {
  console.info(`Changing option ${title}:`);
  var inputSize = $('.swatchEntry input[title*="' + title + '"]').length;
  if (inputSize > 0) {
    var pBlock = $('.swatchEntry input[title*="' + title + '"]').closest(
      '.builderBlock',
    );
    var pBlockQ = pBlock.attr('data-question');
    // console.log(
    //   'question:' +
    //     pBlockQ +
    //     '|title:' +
    //     title +
    //     '|disable:' +
    //     disable +
    //     '|event:' +
    //     swatchParentEventTitle,
    // );
    if (disable == true) {
      $('.swatchEntry input[title*="' + title + '"]').prop('disabled', true);
      // if (swatchParentEventTitle.indexOf(pBlockQ) == -1) {
      // }
      if ($('.swatchEntry input[title*="' + title + '"]:checked').length > 0) {
        pBlock.find('.swatchEntry input').prop('checked', false);
        pBlock.find('[data-property]').val('');
      }
      $('.swatchEntry input[title*="' + title + '"]')
        .prop('disabled', true)
        .prop('checked', false);
    } else {
      $('.swatchEntry input[title*="' + title + '"]').prop('disabled', false);
      // if (swatchParentEventTitle.indexOf(pBlockQ) == -1) {
      // }
      // pBlock.find('.swatchEntry input').prop('checked', false);
      // $('.swatchEntry input[title*="'+title+'"]').prop('checked', false);
      // pBlock.find('[data-property]').val('');
    }
  }
}

setTimeout(function () {
  $('body').addClass('builderLoaded');
}, 300);

function checkValanceMounting() {
  //ADDED BY BLUESWITCH TO CHECK VALANCE OPTIONS
  if (swatchParentEventTitle == 'choose mount type') {
    //TWO VALUES I/O
    var selectedMT = $('.valance-opt input:checked').closest('li').data('sku');

    //DISABLE 2 ITEMS.
    if (selectedMT == 'O') {
      $('.valance-opt-fr').css('opacity', '0.4');
      $('.valance-opt-fr input').prop('disabled', true);

      $('.valance-opt-pr').css('opacity', '0.4');
      $('.valance-opt-pr input').prop('disabled', true);

      $('.valance-opt-nr').css('opacity', '1');
      $('.valance-opt-nr input').prop('disabled', false);

      //ADDED BY BLUESWITCH TO DISABLE ROUNDED CORNERS
      $('.valance-opt-rounded').css('opacity', '1');
      $('.valance-opt-rounded input').prop('disabled', false);
    } else if (selectedMT == 'I') {
      $('.valance-opt-fr').css('opacity', '1');
      $('.valance-opt-fr input').prop('disabled', false);

      $('.valance-opt-pr').css('opacity', '1');
      $('.valance-opt-pr input').prop('disabled', false);

      $('.valance-opt-nr').css('opacity', '0.4');
      $('.valance-opt-nr input').prop('disabled', true);

      //ADDED BY BLUESWITCH TO DISABLE ROUNDED CORNERS
      $('.valance-opt-rounded').css('opacity', '0.4');
      $('.valance-opt-rounded input').prop('disabled', true);
    }
  }

  if (swatchParentEventTitle == 'choose valance options') {
    var selectedV = $('.valance-radio input:checked').attr('title');

    if (selectedV == 'outside mount not recessed') {
      $("li.valance-opt[data-sku='I'] input").prop('disabled', true);
      $("li.valance-opt[data-sku='O'] input").prop('disabled', false);
    } else {
      $("li.valance-opt[data-sku='O'] input").prop('disabled', true);
      $("li.valance-opt[data-sku='I'] input").prop('disabled', false);
    }
  }

  //ADDED BY BLUESWITCH FOR ROUNDED CORNERS.
  if (swatchParentEventTitle == 'choose valance style') {
    var selectedV = $('.valance-radio input:checked').attr('title');

    if (
      selectedV ==
      'round corner valance (available on outside mount blinds only)'
    ) {
      $("li.valance-opt[data-sku='I'] input").prop('disabled', true);
      $("li.valance-opt[data-sku='O'] input").prop('disabled', false);
    } else {
      $("li.valance-opt[data-sku='O'] input").prop('disabled', false);
      $("li.valance-opt[data-sku='I'] input").prop('disabled', false);
    }
  }
}

$(function () {
  $('#product-details').accordion({
    collapsible: true,
    active: false,
    heightStyle: 'content',
  });
});
